<template>
  <div class="tab-pane active assessment-auth-page" id="estimates-table" role="tabpanel">
    <div class="tabs-component tabs-component-2" :class="{'is-mobile': isMobile}">
      <!-- <div class="navbar navbar-light bg-grey navbar-bottom-line b-a mb-2"> -->
    </div>
    <div class="row mt-1" :class="{'no-gutter': isMobile, 'd-flex': true}">

      <div class="estimate-item-list" id="estimate-item-list">
        <!-- <div class="box bg-grey"> -->
        <!-- <p v-if="availableCards.length">No records selected. Please click on items available in two panes on the left side.</p> -->
        <vue-context ref="rightClickMenuForAuthorisation" @close='closeContext' @open='openContext'
                     :close-on-click="false"
                     style="width: 205px !important; height: auto">
          <ul slot-scope="item">
            <li v-if="item && item.data && item.data.part.adj_approve_status !== 'approved'"
                @click="approveOrSetNonePart(item.data.part, 'approved', true)">Approve
            </li>
            <li v-if="item && item.data && item.data.part.adj_approve_status !== 'reported'"
                @click="markOnReportOrDecline(item, 'reported')">On Report
            </li>
            <li v-if="item && item.data && item.data.part.adj_approve_status !== 'denied'"
                @click="markOnReportOrDecline(item, 'denied')">Decline
            </li>
            <template v-if="item && item.data && item.data.type !== 'Materials'">
              <li v-if="item && item.data && item.data.part && item.data.part.comments && !item.data.part.comments.manualComment"
                  class="hasSubContext">Add Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
                <div style="width: 160px !important;  left:203px !important;"
                     class="context-level subContext estimate-item-comment"
                     :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                <textarea
                    v-model="currentInternalComment"
                    ref="commentEditTextarea"
                    placeholder="Add Internal Comment...">
                </textarea>
                  <div class="">
                    <p :class="{'error-text': currentInternalComment.length > 50}" class="comment-limit-text">Limit of
                      50
                      characters</p>
                    <i @click="$set(item.data.part.comments, 'manualComment', currentInternalComment); $set(item.data.part.comments, 'manualCommentAuthor', userInfo.full_name); currentInternalComment = ''; $refs.rightClickMenuForAuthorisation.close();"
                       class='bx bx-save save-comment-icon'></i>
                  </div>
                </div>
              </li>
              <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment"
                  class="hasSubContext">Edit Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
                <div style="width: 160px !important;  left:203px !important;"
                     class="context-level subContext estimate-item-comment"
                     :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                <textarea
                    ref="commentEditTextarea"
                    v-model="item.data.part.comments.manualComment"
                    placeholder="Edit Internal Comment...">
                </textarea>
                  <div class="">
                    <p :class="{'error-text': item.data.part.comments.manualComment.length > 50}"
                       class="comment-limit-text">Limit of 50 characters</p>
                    <i @click="$refs.rightClickMenuForAuthorisation.close();"
                       class='bx bx-save save-comment-icon'></i>
                  </div>
                </div>
              </li>
              <li v-if="item && item.data && item.data.part && item.data.part.comments.manualComment"
                  @click="item.data.part.comments.manualComment = ''; item.data.part.comments.manualCommentAuthor = ''; $refs.rightClickMenuForAuthorisation.close();">
                Remove Internal Comment
              </li>

              <li v-if="item && item.data && item.data.part && item.data.part && !item.data.part.externalComment"
                  class="hasSubContext">Add External Comment <i
                  class="icon-right bx bx-chevron-right"></i>
                <div style="width: 160px !important;  left:203px !important;"
                     class="context-level subContext estimate-item-comment"
                     :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                <textarea
                    v-model="currentExternalComment"
                    ref="commentEditTextarea"
                    placeholder="Add External Comment...">
                </textarea>
                  <div class="">
                    <p :class="{'error-text': currentExternalComment.length > 50}" class="comment-limit-text">Limit of
                      50
                      characters</p>
                    <i @click="$set(item.data.part, 'externalComment', currentExternalComment); currentExternalComment = ''; $refs.rightClickMenuForAuthorisation.close(); "
                       class='bx bx-save save-comment-icon'></i>
                  </div>
                </div>
              </li>
              <li v-if="item && item.data && item.data.part && item.data.part && item.data.part.externalComment"
                  class="hasSubContext">Edit External Comment <i
                  class="icon-right bx bx-chevron-right"></i>
                <div style="width: 160px !important;  left:203px !important;"
                     class="context-level subContext estimate-item-comment"
                     :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                <textarea
                    ref="commentEditTextarea"
                    v-model="item.data.part.externalComment"
                    placeholder="Edit External Comment...">
                </textarea>
                  <div class="">
                    <p :class="{'error-text': item.data.part.externalComment.length > 50}"
                       class="comment-limit-text">Limit of 50 characters</p>
                    <i @click="$refs.rightClickMenuForAuthorisation.close();"
                       class='bx bx-save save-comment-icon'></i>
                  </div>
                </div>
              </li>
              <li v-if="item && item.data && item.data.part && item.data.part.externalComment"
                  @click="item.data.part.externalComment = ''; $refs.rightClickMenuForAuthorisation.close();">Remove
                External Comment
              </li>

              <li v-if="item && item.data && item.data.part && item.data.part.comments && !item.data.part.comments.manualPdfComment"
                  class="hasSubContext">Add Estimate Comment <i
                  class="icon-right bx bx-chevron-right"></i>
                <div style="width: 160px !important;  left:203px !important;"
                     class="context-level subContext estimate-item-comment"
                     :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                <textarea
                    v-model="currentEstimateItemComment"
                    ref="commentEditTextarea"
                    placeholder="Add Estimate Comment...">
                </textarea>
                  <div class="">
                    <p :class="{'error-text': currentEstimateItemComment.length > 50}" class="comment-limit-text">Limit
                      of 50
                      characters</p>
                    <i @click="$set(item.data.part.comments, 'manualPdfComment', currentEstimateItemComment); $set(item.data.part.comments, 'manualPdfCommentAuthor', userInfo.full_name); currentEstimateItemComment = ''; $refs.rightClickMenuForAuthorisation.close(); "
                       class='bx bx-save save-comment-icon'></i>
                  </div>
                </div>
              </li>
              <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualPdfComment"
                  class="hasSubContext">Edit Estimate Comment <i
                  class="icon-right bx bx-chevron-right"></i>
                <div style="width: 160px !important;  left:203px !important;"
                     class="context-level subContext estimate-item-comment"
                     :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                <textarea
                    ref="commentEditTextarea"
                    v-model="item.data.part.comments.manualPdfComment"
                    placeholder="Edit Estimate Comment...">
                </textarea>
                  <div class="">
                    <p :class="{'error-text': item.data.part.comments.manualPdfComment.length > 50}"
                       class="comment-limit-text">Limit of 50 characters</p>
                    <i @click="$refs.rightClickMenuForAuthorisation.close();"
                       class='bx bx-save save-comment-icon'></i>
                  </div>
                </div>
              </li>
              <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualPdfComment && !isOnReport(item.data.part)"
                  @click="item.data.part.comments.manualPdfComment = ''; item.data.part.comments.manualPdfCommentAuthor = ''; $refs.rightClickMenuForAuthorisation.close();">
                Remove Estimate Comment
              </li>
            </template>
          </ul>
        </vue-context>
        <div class="authorise-estimate-header d-flex justify-content-between" style="min-width: 900px">
          <div class="authorise-estimate-title">ASSESSMENT AUTHORISATION</div>
          <div class="d-flex">
            <div class="form-group row d-flex assessment-assessor-name" style="margin-bottom: 0px !important;">
              <label class="col-form-label assessment-assessor-name-title">Assessor Name</label>
              <div class="">
                <advanced-search ref="assessor_name"
                                 class="assessment-assessor-name-input"
                                 v-model="estimate.authorisedBy"
                                 :class="{active: estimate.authorisedByCustomer}"
                                 :searchData="insurerAssessors"
                                 @onSelect="onAssessorSelect"
                                 :searchKey="'assessor_name'"
                                 :searchLabel="'Assessor'"
                                 placeholder="Assessor Name"
                                 :isDisabled="!isStatusActive || estimate.authorisedByCustomer || isAuthorised"></advanced-search>
              </div>
            </div>

            <div class="form-group row d-flex " style="margin-bottom: 0px !important; align-items: center">
              <label class="form-check-inline checkbox">
                <input class="form-check-input" v-model="estimate.authorisedByCustomer"
                       :disabled="!isStatusActive || isAuthorised" type="checkbox">
                <span class="icon"><i class='bx bx-check'></i></span><span class="text" style="width: 122px;">By Customer</span>
              </label>
            </div>
          </div>


          <div>
            <button v-if="!isAuthorised" @click="cancelPage" type="button"
                    class="btn btn-primary authorise-estimate-cancel">
              Cancel
            </button>
            <button v-if="isAuthorised" @click="cancelPage" type="button"
                    class="btn btn-primary authorise-estimate-cancel">
              Close
            </button>
            <button v-if="isAuthorised" @click="$refs.cancelAuthorityModal.show()" type="button" class="btn btn-primary"
                    style="margin-right: 15px">
              Cancel Authority
            </button>
            <button @click="confirmAuthorisation" :disabled="isAuthorised" :class="{'btn-disabled':isAuthorised}"
                    type="button" class="btn btn-primary " style="margin-right: 10px;">
              Authorise
            </button>
          </div>

        </div>
        <div v-for="(card, index) in availableCards"
             class="autorise-estimate-table"
             :class="{'display-none': card == 'MaterialsCalc' || _isEmpty(getNotAuthorisedParts(estimateParts[card]))}"
             :key="index">
          <div
              :class="{'part-table-min-width': card == 'Part', 'pdr-table-min-width': card == 'PDR', 'paint-table-min-width': card == 'Paint', 'others-table-min-width': card == 'RR' || card == 'Repair' || card == 'Materials' || card == 'Sublet' || card == 'Other'}"
              class="card-header bg-navyblue" style="display: flex; margin-right: 10px; margin-left: 10px">
            <strong>{{ card }}</strong>

            <div class="d-flex"
                 style="justify-content: end; flex-wrap: wrap; margin-left: auto;">
              <div class="d-flex">
                <label style="min-width: 115px; text-align: right; margin-right: 10px" class="col-sm-4 col-form-label">{{
                    card
                  }}
                  - Subtotal</label>
                <span style="max-width: 100px; height: 32px"
                      class="form-control">{{ calculatedTotalByCard(card) |formatMoney }}</span>

                <!--                                <number-formatter ref="total"-->
                <!--                                                  v-model="calculatedTotal"-->
                <!--                                                  type="text"-->
                <!--                                                  class="form-control"-->
                <!--                                                  id="total"-->
                <!--                                                  placeholder="Total"-->
                <!--                                                  :isTotalManual="true"-->
                <!--                                                  format="$0,0.00"-->
                <!--                                                  style="max-width: 100px;"-->
                <!--                                                  readonly="true">-->
                <!--                                </number-formatter>-->
              </div>
              <div class="d-flex" style="margin-left: 10px;">
                <label style="width: auto; text-align: right; margin-right: 10px" class="col-sm-4 col-form-label">
                  ADJ Subtotal</label>
                <div class="d-flex" style="min-width: 140px;">
                                    <span
                                        v-if="calculatedAdjTotalByCard(card) !== calculatedTotalByCard(card)  && calculatedTotalByCard(card)  !== 0"
                                        class="form-control"
                                        :style="{color: calculatedAdjTotalByCard(card) > calculatedTotalByCard(card)  ? '#2BAE66FF': 'red'}"
                                        style="line-height: 16px; height: 32px !important;">
                                      {{ calculatedAdjTotalByCard(card)|formatMoney }}
                                    </span>
                  <span v-else class="form-control white-text"
                        style="color: red; display: inline; line-height: 16px; height: 32px !important;  margin-left: 5px"></span>

                  <span
                      v-if="calculatedAdjTotalByCard(card) !== calculatedTotalByCard(card)  && calculatedTotalByCard(card)  !=0"
                      class="form-control"
                      :style="{color: calculatedAdjTotalByCard(card) > calculatedTotalByCard(card)  ? '#2BAE66FF': 'red'}"
                      style="line-height: 16px; height: 32px !important;  margin-left: 5px">
                                      {{ calculatedAdjTotalPercentByCard(card) }}%
                                    </span>
                  <span v-else :class="{'white-text': calculatedAdjTotalByCard(card) === calculatedTotalByCard(card) }"
                        class="form-control white-text"
                        style="color: red; line-height: 16px; height: 32px !important;  margin-left: 5px">
                                    </span>
                </div>
              </div>
            </div>


          </div>
          <div
              :class="{'part-table-min-width': card == 'Part', 'pdr-table-min-width': card == 'PDR', 'paint-table-min-width': card == 'Paint', 'others-table-min-width': card == 'RR' || card == 'Repair' || card == 'Materials' || card == 'Sublet' || card == 'Other'}"
              class="card-block rs-scroll rs-scroll--x rs-scroll--y px-0 py-0 bg-white estimate-items-wrapper"
              style="overflow: visible">
            <div class="mb-1 estimate-items disabled-draggable" id="table-1"
                 :class="{ 'width-rr': card === 'RR' || card === 'Repair' || card === 'Materials' || card === 'Sublet', 'width-paint': card === 'Paint', 'width-parts': card === 'Part', 'width-other': card === 'Other', 'width-pdr': card === 'PDR'}"
            >
              <div>
                <div class="estimate-items-title"
                     :class="{'h-66px': card == 'RR' || card == 'Repair' || card == 'Paint'}">
                  <div style="padding-left: 15px;" class="estimate-items-name-all">Name</div>
                  <div v-if="card === 'Part'"
                       class="text-center numeric estimate-items-title-content estimate-items-part-num">Part Number
                  </div>
                  <div v-if="card === 'Part'"
                       class="text-center numeric estimate-items-title-content estimate-items-part-num">Type
                  </div>
                  <div v-if="card === 'Part' " class="text-center numeric estimate-items-title-content">M/up (%)</div>
                  <div v-if="card === 'PDR'"
                       class="text-center numeric estimate-items-title-content estimate-items-pdr">Material
                  </div>
                  <div v-if="card === 'PDR'"
                       class="text-center numeric estimate-items-title-content estimate-items-pdr">Action
                  </div>
                  <div v-if="card === 'Part' || card === 'PDR'"
                       class="text-center numeric numeric-qty estimate-items-title-content"
                       style="width: 50px !important;">Qty
                  </div>
                  <div v-if="card === 'Paint'"
                       class="text-center  numeric estimate-items-title-content estimate-items-paint-materials">Paint
                    Material
                  </div>
                  <div v-if="card === 'Sublet'" class="estimate-items-title-content">Repairer</div>
                  <div
                      v-if="card !== 'Part' && card !== 'Sublet' && card !== 'Other' && card !== 'PDR' && !isHideTitle(card)"
                      class="text-center estimate-items-title-content estimate-items-hrs">Hrs
                    <span
                        v-if="card == 'RR' || card == 'Repair' || card == 'Paint'"><br/>Total: {{
                        getTotal('hrs', card)
                      }}</span>
                  </div>
                  <div v-if="card === 'Sublet'" class="text-center numeric estimate-items-title-content">M/up (%)</div>
                  <div v-if="card !== 'Part' &&  card !== 'Sublet'  && card !== 'Other' && !isHideTitle(card)"
                       class="text-center estimate-items-title-content  estimate-items-adj">ADJ
                    <span
                        v-if="card == 'RR' || card == 'Repair' || card == 'Paint'"><br/>Total: {{
                        getTotal('adj_hrs', card)
                      }}</span>
                  </div>
                  <div v-if="card === 'Part'" class="text-center estimate-items-title-content estimate-items-rate">Buy
                  </div>
                  <div v-if="card !== 'Other' && card !== 'Materials' && card !== 'PDR' && !isHideTitle(card)"
                       class="text-center numeric estimate-items-title-content estimate-items-rate"
                       style="padding-left: 0px">

                    <div class="text-align-center">
                      {{
                        card ==
                        'Part' ? 'List' : 'Rate'
                      }}
                    </div>

                    <div class="" v-if="estimate.adjRates">
                      <number-formatter v-model="estimate.adjRates[card.toLowerCase()]" type="text" class="form-control"
                                        :placeholder="'Rate '"
                                        v-if="card == 'RR' || card == 'Repair' || card == 'Paint'"
                                        format="$0,0.00"
                                        :is-disabled="!isStatusActive || isAuthorised"
                                        style="text-align: right; width: 75px;     margin-left: 9px;"
                                        :style="{color: Number(estimate.adjRates[card.toLowerCase()]) > Number(estimateRates[card.toLowerCase()]) ? '#2BAE66FF': ((Number(estimate.adjRates[card.toLowerCase()]) < Number(estimateRates[card.toLowerCase()])) ? 'red' : 'black')}"
                                        @onChange="setRateForAll(card, estimate.adjRates[card.toLowerCase()])"></number-formatter>
                    </div>

                  </div>
                  <div v-if="card === 'PDR'" class="text-center numeric estimate-items-title-content">Price</div>
                  <div class="text-center numeric estimate-items-title-content estimate-items-total">Total</div>
                  <div class="text-center numeric estimate-items-content-adj">ADJ</div>
                  <div class="estimate-items-content-btn-remove">
                    <label class="form-check-inline checkbox" style="padding-top: 8px;"
                           :class="{'checkbox-part-margin-left': card == 'Part'}">
                      <input :disabled="!isStatusActive || isAuthorised" class="form-check-input"
                             name="hide-series-checkbox"
                             v-model="checkedAll[card]"
                             @change="checkAll(card, checkedAll[card])"
                             type="checkbox">
                      <span class="icon" style="left: 5px; bottom: 9px"><i class='bx bx-check' style="margin: 0px"></i></span><span
                        class="text"></span>
                    </label>
                  </div>
                </div>
              </div>
              <template v-if="card == 'Part'">
                <draggable v-model="estimateParts[card]"
                           class="dragArea"
                           tag="div"
                           handle=".handle"
                           :animation="150"
                           :disabled="isMobile || !isStatusActive || isAuthorised"
                           :group="{
                                            name: 'items',
                                            put: true // not allow(false) or allow(true) items to be put into this list
                                        }"
                           ghost-class="ghost-items"
                           style="margin: 0 5px"
                >
                  <template v-for="(part, index) in estimateParts[card]">
                    <estimate-item :ref="card + '-' + part.id"
                                   v-if="(!part.isNotCreated || part.isNotCreated === false) && !part.addedByAssessor"
                                   :key="card + '-' + part.id"
                                   :card="card"
                                   :isAuthorisePage="true"
                                   v-bind="part"
                                   :item="part"
                                   :isItemNew="isNew(part.id)"
                                   :isAuthorizedItemList="isAuthorised"
                                   :isEstimateMethodologyCustom="isEstimateMethodologyCustom"
                                   :item2="estimateParts[card][getOriginalIndex(estimateParts[card], part.id)]"
                                   :properties="properties"
                                   @update:item="val => {$set(estimateParts[card], getOriginalIndex(estimateParts[card], part.id), val)}"
                                   :index="'partid-' + (index + 1)"
                                   :estimateMethodology="estimateMethodology"
                                   :isInsuranceRepairYes="true"
                                   :isMovedElement="false"
                                   :isNegativeValueCanBeRed="isNegativeValueCanBeRed"
                                   :showEnviromentLevy='isShowEnvironmentLevyCalculation'
                                   :showPaintSetupTime='isShowPaintSetupCalculation'
                                   :isClickedConfirmAuthorisation="isClickedConfirmAuthorisation"
                                   v-bind:isOverrided="estimateParts[card][getOriginalIndex(estimateParts[card], part.id)].isOverrided"
                                   @remove="removeEstimatePart(card,getOriginalIndex(estimateParts[card], part.id))"
                                   @checkedItem="checkedItems"
                                   @onKeyPress="onKeyPress"
                                   @onChangeHrs="preAuthorizeCalculation(card)"
                                   @onKeyPressEnter="onEnterKeyPress(part.id, getOriginalIndex(estimateParts[card], part.id), ...arguments)"
                                   @onKeyPressLeft="onLeftKeyPress(index, part.id, ...arguments)"
                                   @onKeyPressRight="onRightKeyPress(index, part.id, ...arguments)"
                                   @onKeyPressUp="onUpKeyPress(part.id, true, ...arguments)"
                                   @onKeyPressDown="onDownKeyPress(part.id, true, ...arguments)"
                                   :showPDRPrice="true"
                                   @openRightMenu="e => openRightMenu(e, getOriginalIndex(estimateParts[card]), part, card)"
                                   :isEnableManualAdj="true"
                    >
                    </estimate-item>
                  </template>
                </draggable>
              </template>
              <template v-else>
                <template v-for="(part, index) in getNotAuthorisedParts(estimateParts[card])">
                  <estimate-item :ref="card + '-' + part.id"
                                 v-if="!part.isNotCreated || part.isNotCreated === false"
                                 :key="card + '-' + part.id"
                                 :card="card"
                                 :isAuthorisePage="true"
                                 v-bind="part"
                                 :item="part"
                                 :isAuthorizedItemList="isAuthorised"
                                 @onChangeHrs="preAuthorizeCalculation(card)"
                                 :isItemNew="isNew(part.id)"
                                 :item2="estimateParts[card][getOriginalIndex(estimateParts[card], part.id)]"
                                 :properties="properties"
                                 @update:item="val => {$set(estimateParts[card], getOriginalIndex(estimateParts[card], part.id), val)}"
                                 :index="'partid-' + (index + 1)"
                                 :estimateMethodology="estimateMethodology"
                                 :isInsuranceRepairYes="true"
                                 :isMovedElement="false"
                                 :isNegativeValueCanBeRed="isNegativeValueCanBeRed"
                                 :showEnviromentLevy='isShowEnvironmentLevyCalculation'
                                 :showPaintSetupTime='isShowPaintSetupCalculation'
                                 :isClickedConfirmAuthorisation="isClickedConfirmAuthorisation"
                                 v-bind:isOverrided="estimateParts[card][getOriginalIndex(estimateParts[card], part.id)].isOverrided"
                                 @remove="removeEstimatePart(card,getOriginalIndex(estimateParts[card], part.id))"
                                 @checkedItem="checkedItems"
                                 @onKeyPress="onKeyPress"
                                 @onKeyPressEnter="onEnterKeyPress(part.id, getOriginalIndex(estimateParts[card], part.id), ...arguments)"
                                 @onKeyPressLeft="onLeftKeyPress(index, part.id, ...arguments)"
                                 @onKeyPressRight="onRightKeyPress(index, part.id, ...arguments)"
                                 @onKeyPressUp="onUpKeyPress(part.id, true, ...arguments)"
                                 @onKeyPressDown="onDownKeyPress(part.id, true, ...arguments)"
                                 :showPDRPrice="true"
                                 @openRightMenu="e => openRightMenu(e, getOriginalIndex(estimateParts[card]), part, card)"
                                 :isEnableManualAdj="true"
                  >
                  </estimate-item>
                </template>
              </template>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end">

          <div class="d-flex justify-content-end " style="flex-direction: column">
            <div class="form-group row d-flex pl-1 justify-content-end" style="align-items: center; margin-top: 0px">
              <label class="col-form-label">ADJ Subtotal</label>
              <div class="">
                <input :value="calculatedAdjSubtotal2 | formatMoney" style="width: 110px; margin-left: 15px"
                       class="form-control" :readonly="true"/>
              </div>
            </div>

            <div class="form-group row d-flex pl-1 justify-content-end" style="align-items: center; ">
              <label class="col-form-label">ADJ GST</label>
              <div class="">
                <input :value="calculatedAdjSubtotalGst | formatMoney" style="width: 110px; margin-left: 15px"
                       class="form-control" :readonly="true"/>
              </div>
            </div>

            <div class="form-group row d-flex pl-1 justify-content-end" style="align-items: center; ">
              <label class="col-form-label">ADJ Grand Total</label>
              <div class="">
                <input :value="calculatedAdjGrandSubtotal |formatMoney" style="width: 110px; margin-left: 15px"
                       class="form-control" :readonly="true"/>
              </div>
            </div>
          </div>
        </div>

        <div class="authorise-estimate-header d-flex justify-content-end" style="margin-top: 30px">
          <div class="authorise-estimate-title"></div>
          <button v-if="!isAuthorised" @click="cancelPage" type="button"
                  class="btn btn-primary authorise-estimate-cancel">
            Cancel
          </button>
          <button v-if="isAuthorised" @click="cancelPage" type="button"
                  class="btn btn-primary authorise-estimate-cancel">
            Close
          </button>
          <button v-if="isAuthorised" @click="$refs.cancelAuthorityModal.show()" type="button" class="btn btn-primary"
                  style="margin-right: 15px">
            Cancel Authority
          </button>
          <button @click="confirmAuthorisation" :disabled="isAuthorised" :class="{'btn-disabled':isAuthorised}"
                  type="button" class="btn btn-primary " style="margin-right: 10px;">
            Authorise
          </button>
        </div>
      </div>
    </div>
    <modal-wizard class="modal-cancel-authority" ref="cancelAuthorityModal" finishButtonText="Continue"
                  @on-complete="cancelAuthority">
      <modal-wizard-tab title="Cancel Authority">
        <div style="margin-bottom: 15px; margin-top:5px; font-weight: bold">
          Are you sure that you need to cancel authorization? <br/>All parts will have their authorization canceled and
          they can be edited.
        </div>
      </modal-wizard-tab>
    </modal-wizard>

    <modal-wizard class="delete-supp-modal" ref="deleteConfirmModal" finishButtonText="Delete Line"
                  @on-complete="removeEstimatePart(currentPartForRemoving.card, currentPartForRemoving.index, true)">
      <modal-wizard-tab title="Delete Line">
        <div style="margin-bottom: 15px; margin-top:5px">
          Are you sure you want to delete this Line?
        </div>
      </modal-wizard-tab>
    </modal-wizard>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isMobile } from '../../../deviceDetect/index'
import { VueContext } from 'vue-context'
import RsRipple from '../../rs-ripple.vue'
import accounting from 'accounting'
import dragDropItems from '../../../mixins/drag-drop-items'
import NumberFormatter from '../../utility/number-formatter'
import EstimateItem from '../../utility/estimate-item'
import _ from 'lodash'
import Axios from 'axios'
import datePicker from '@/components/utility/date-picker.vue'
import draggable from 'vuedraggable'
import AdvancedSearch from '../../utility/advanced-search'
import numeral from 'numeral'

export default {
  name: 'assessment-auth',
  mixins: [
    dragDropItems,
  ],
  props: {
    isAutoSave: {
      type: Boolean,
      default: false,
    },
    isRSEstimateMethodology: {
      type: Boolean,
      default: false,
    },
    isEstimateMethodologyCustom: {
      type: Boolean,
      default: false,
    },
    estimateMethodology: {
      type: String,
      default: 'Custom',
    },
    properties: {
      type: Object,
      default () {
        return {
          isAutoSave: true,
          isFromIag: true,
          isFromEio: true,
        }
      }
    },
    card: {
      type: Object,
      default () {
        return {}
      }
    },
    assessors: {
      type: Object,
      default () {
        return []
      }
    },
    timesForItemPart: {},
    vehicleBody: '',
    rates: {
      type: Object,
      default () {
        return {
          paint_material: 'not_set',
          paint: 0,
          repair: 0,
          rr: 0,
          rs_paint_percentage: 20,
          rs_rr_percentage: 20,
        }
      }
    },
    estimate: {
      type: Object,
      default () {
        return {
          isShowPaintSetupCalculation: true,
          isShowEnvironmentLevyCalculation: true,
          amount: 0,
          gstAmount: 0,
          isAuthorised: false,
        }
      }
    },
    estimateId: 0,
    isShowPaintSetupCalculation: {
      type: Boolean,
      default: true,
    },
    isShowEnvironmentLevyCalculation: {
      type: Boolean,
      default: true,
    },
    isSentToIntegrationSystem: {
      type: Boolean,
      default: false,
    },
    estimateParts: [],
  },
  data () {
    return {
      currentPartForRemoving: null,
      removeEstimateParts: [],
      isMobile,
      checkedAll: {},
      isClickedConfirmAuthorisation: false,
      isNotActiveOptionVehicleMakeOrModel: false,
      estimatePartsBeforeAuthorisation: [],
      selectedEstimateItem: {
        part: {},
        type: '',
      },
      isMovedElement: false,
      currentManualItemComment: '',
      currentInternalComment: '',
      currentExternalComment: '',
      currentEstimateItemComment: ''
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
      isStatusActive: 'isStatusActive',
    }),
    isEstimateMethodologyDollars () {
      return (this.estimateMethodology == 'dollars')
    },
    estimateRates () {
      return this.rates
    },
    isAuthorised () {
      return !!(this.estimate.isAuthorised)
    },
    insurerAssessors: function () {
      if (this.card.insurance.insurer_id) {
        return _.sortBy(this.assessors[this.card.insurance.insurer_id], [function (assessor) {
          return assessor.assessor_name.trim().toLowerCase()
        }])
      }

      return []
    },
    availableCards: function () {
      return ['RR', 'Repair', 'Paint', 'Part', 'Materials', 'Sublet', 'Other', 'PDR',]
    },
    isNegativeValueCanBeRed () {
      return ((this.properties.isFromIag === true || this.properties.isFromEio) && this.estimate.type === 'supplement')
    },
    calculatedSubtotal () {
      let a = 0
      for (let type in this.estimateParts) {
        let items = this.estimateParts[type]
        for (let item of items) {
          if (item) {
            switch (type) {
              case 'Paint':
              case 'Repair':
              case 'RR':
                if (item.isSupplementDeletion) {
                  break
                }
                if (this.isEstimateMethodologyDollars) {
                  a += this.pT(item.rate)
                  break
                }
                if (item.total_manual != null) {
                  a += this.pT(item.total_manual)
                  break
                }
                a += this.pT(item.total)
                break
              case 'Part':
                if (item.isSupplementDeletion) {
                  break
                }
                a += this.pT(item.total)
                break
              case 'Material':
              case 'Materials':
                if (item.type === 'calculation' && item.original_total) {
                  a += this.pT(item.original_total)
                } else if (item.type === 'calculation' && item.rs_rate) {
                  a += this.pT(item.rs_rate)
                } else {
                  a += this.pT(item.rate)
                }
                break
              case 'Sublet':
              case 'PDR':
                if (item.isSupplementDeletion) {
                  break
                }
                a += this.pT(item.price * item.qty)
                break
              case 'Other':
                if (item.isSupplementDeletion) {
                  break
                }
                a += this.pT(item.rate)
                break
            }
          }
        }
      }
      return a
    },
    calculatedAdjSubtotal () {
      let a = 0
      for (let type in this.estimateParts) {
        let items = this.estimateParts[type]
        for (let item of items) {
          if (item) {
            if (item.adj_approve_status == 'reported' || item?.adj_approve_status == 'denied') {
              continue
            }
            switch (type) {
              case 'Paint':
              case 'Repair':
              case 'RR':
                if (item.isSupplementDeletion) {
                  break
                }
                if (this.isEstimateMethodologyDollars) {
                  a += item.adj_rate != null ? this.pT(item.adj_rate) : this.pT(item.rate)
                  break
                }
                if (item.adj_rate != null && type !== 'Paint') {
                  a += this.pT(item.adj_rate)
                  break
                }
                if (item.adj_hrs != null) {
                  let h = item.adj_hrs
                  a += this.pT(this.pT(h) * this.pT(item.rate))
                  break
                }
                if (item.total_manual != null) {
                  a += this.pT(item.total_manual)
                  break
                }
                a += this.pT(item.total)
                break
              case 'Part':
                if (item.isSupplementDeletion) {
                  break
                }
                if (item.adj_rate != null) {
                  a += this.pT(item.adj_rate)
                } else {
                  a += this.pT(item.total)
                }
                break
              case 'Material':
              case 'Materials':
                let isUseCalcValue = false
                if ((this.properties.isFromEio || this.properties.isFromIag) && item.type == 'calculation') {
                  let r = 0
                  if (item.adj_rate && item.original_total && item.adj_rate == item.original_total) {
                    r = 0
                  } else if (item.adj_rate) {
                    r = item.adj_rate
                  } else if (item.original_total) {
                    r = item.original_total
                  }
                  if (r) {
                    isUseCalcValue = true
                    a += this.pT(r)
                  }
                }

                if (!isUseCalcValue) {
                  let adj_rate = item.adj_rate
                  if (item.subtype !== 'EnvironmentLevy') {
                    let hrs = null
                    if (item.type === 'manual') {
                      hrs = item.hrs
                    } else {
                      if (item.original_hrs && item.original_hrs !== null) {
                        hrs = item.original_hrs
                      } else if (item.rs_hrs && item.rs_hrs !== null) {
                        hrs = item.rs_hrs
                      } else {
                        hrs = item.hrs
                      }
                    }
                    let rate = item.material_rate

                    if (item.adj_hrs == null) {
                      adj_rate = null
                    } else if (item.adj_hrs == 0) {
                      adj_rate = 0
                    } else if (hrs != '' && hrs != null) {
                      adj_rate = accounting.toFixed(rate * item.adj_hrs, 2)
                    }
                  }

                  if (item.subtype == 'PaintSetupTime' && item.adj_hrs == null && item.adj_rate !== null) {
                    adj_rate = item.adj_rate
                  }

                  if (adj_rate !== null && adj_rate !== undefined && adj_rate !== '' && !isNaN(parseFloat(adj_rate))) {
                    a += this.pT(adj_rate)
                  } else if (item.original_total !== null && item.original_total !== undefined && item.original_total !== '' && !isNaN(parseFloat(item.original_total))) {
                    a += this.pT(item.original_total)
                  } else if (item.rs_rate && !isNaN(parseFloat(item.rs_rate))) {
                    a += this.pT(item.rs_rate)
                  } else if (!isNaN(parseFloat(item.rate))) {
                    a += this.pT(item.rate)
                  }
                }
                break
              case 'PDR':
                if (item.isSupplementDeletion) {
                  break
                }
                if (item.adj_price !== null && item.adj_price !== undefined && item.adj_price !== '') {
                  a += this.pT(item.adj_price)
                } else {
                  a += this.pT(this.pT(item.price) * this.pT(item.qty))
                }
                break
              case 'Other':
                if (item.isSupplementDeletion) {
                  break
                }
                a += item.adj_rate != null ? this.pT(item.adj_rate) : this.pT(item.rate)
                break
              case 'Sublet':
                if (item.isSupplementDeletion) {
                  break
                }
                a += item.adj_rate != null ? this.pT(item.adj_rate) : this.pT(item.total)
                break
            }
          }
        }
      }
      this.estimate.amount = _.round(a, 2) + _.round((a * 0.1), 2)
      this.estimate.gstAmount = _.round((a * 0.1), 2)
      return a
    },
    calculatedAdjSubtotal2 () {
      let a = 0
      for (let type in this.estimateParts) {
        let items = this.getNotAuthorisedParts(this.estimateParts[type])
        for (let item of items) {
          if (item && item.isAuthorized) {
            if (item.adj_approve_status == 'reported' || item?.adj_approve_status == 'denied') {
              continue
            }
            switch (type) {
              case 'Paint':
              case 'Repair':
              case 'RR':
                if (item.isSupplementDeletion) {
                  break
                }
                if (this.isEstimateMethodologyDollars) {
                  a += item.adj_rate != null ? this.pT(item.adj_rate) : this.pT(item.rate)
                  break
                }
                if (item.adj_rate != null && type !== 'Paint') {
                  a += this.pT(item.adj_rate)
                  break
                }
                if (item.adj_hrs != null) {
                  let h = item.adj_hrs
                  a += this.pT(this.pT(h) * this.pT(item.rate))
                  break
                }
                if (item.total_manual != null) {
                  a += this.pT(item.total_manual)
                  break
                }
                a += this.pT(item.total)
                break
              case 'Part':
                if (item.isSupplementDeletion) {
                  break
                }
                if (item.adj_rate != null) {
                  a += this.pT(item.adj_rate)
                } else {
                  a += this.pT(item.total)
                }
                break
              case 'Material':
              case 'Materials':
                let isUseCalcValue = false
                if ((this.properties.isFromEio || this.properties.isFromIag) && item.type == 'calculation') {
                  let r = 0
                  if (item.adj_rate && item.original_total && item.adj_rate == item.original_total) {
                    r = 0
                  } else if (item.adj_rate) {
                    r = item.adj_rate
                  } else if (item.original_total) {
                    r = item.original_total
                  }
                  if (r) {
                    isUseCalcValue = true
                    a += this.pT(r)
                  }
                }

                if (!isUseCalcValue) {
                  if (item.adj_rate !== null && item.adj_rate !== undefined && item.adj_rate !== '' && !isNaN(parseFloat(item.adj_rate))) {
                    a += this.pT(item.adj_rate)
                  } else if (item.original_total !== null && item.original_total !== undefined && item.original_total !== '' && !isNaN(parseFloat(item.original_total))) {
                    a += this.pT(item.original_total)
                  } else if (item.rs_rate && !isNaN(parseFloat(item.rs_rate))) {
                    a += this.pT(item.rs_rate)
                  } else if (!isNaN(parseFloat(item.rate))) {
                    a += this.pT(item.rate)
                  }
                }
                break
              case 'PDR':
                if (item.isSupplementDeletion) {
                  break
                }
                if (item.adj_price !== null && item.adj_price !== undefined && item.adj_price !== '') {
                  a += this.pT(item.adj_price)
                } else {
                  a += this.pT(this.pT(item.price) * this.pT(item.qty))
                }
                break
              case 'Other':
                if (item.isSupplementDeletion) {
                  break
                }
                a += item.adj_rate != null ? this.pT(item.adj_rate) : this.pT(item.rate)
                break
              case 'Sublet':
                if (item.isSupplementDeletion) {
                  break
                }
                a += item.adj_rate != null ? this.pT(item.adj_rate) : this.pT(item.total)
                break
            }
          }
        }
      }
      this.estimate.amount = _.round(a, 2) + _.round((a * 0.1), 2)
      this.estimate.gstAmount = _.round((a * 0.1), 2)
      return a
    },
    calculatedAdjSubtotalGst () {
      return accounting.toFixed(this.calculatedAdjSubtotal2 * 0.1, 2)
    },
    calculatedAdjGrandSubtotal () {
      return accounting.toFixed(this.calculatedAdjSubtotal2 * 1.1, 2)
    },
    calculatedAdjSubtotalPercent () {
      if (this.calculatedAdjSubtotal == 0 || this.calculatedSubtotal == 0) {
        return 0
      }
      if (this.calculatedAdjSubtotal > this.calculatedSubtotal) {
        let result = accounting.toFixed(-(1 - this.calculatedAdjSubtotal / this.calculatedSubtotal) * 100, 2)
        if (result > 0) {
          return '+' + result
        } else {
          return '+' + (-1 * result)
        }
      }
      let result = accounting.toFixed((1 - this.calculatedAdjSubtotal / this.calculatedSubtotal) * 100, 2)
      if (result > 0) {
        return '-' + result
      } else {
        return result
      }
    },
  },
  mounted () {
    this.setEstimatePartsCopy()
    this.setIsCheckedParts()
    this.setAssessor()
    this.setIsChecked()
    this.setOnReportStatuses()
  },
  methods: {
    isOnReport (part) {
      return part && part.onReportRepairer && part.onReportRepairer.flag
    },
    setOnReportStatuses () {
      _.forEach(this.availableCards, (card) => {
        _.forEach(this.estimateParts[card], (part) => {
          if (part?.onReportRepairer?.flag) {
            this.markOnReportOrDecline({ data: { part: part } }, 'reported')
          }
        })
      })
    },
    isHideTitle (card) {
      return this.isEstimateMethodologyDollars && (card == 'RR' || card == 'Repair' || card == 'Paint')
    },
    getTotal (field, card) {
      let r = 0
      let field2 = 'hrs'
      _.forEach(this.getNotAuthorisedParts(this.estimateParts[card]), (p) => {
        if ((_.isString(p[field]) || _.isNumber(p[field])) && !_.isNaN(p[field])) {
          r += Number(p[field])
        } else if ((field == 'adj_hrs') && (_.isString(p[field2]) || _.isNumber(p[field2])) && !_.isNaN(p[field2])) {
          r += Number(p[field2])
        }
      })
      return numeral(r).format('0,0.00')
    },
    setAssessor () {
      if (_.isEmpty(this.estimate.authorisedBy)) {
        this.estimate.authorisedBy = this.card.insurance.assessor_name
      }
    },
    onAssessorSelect (a) {
      if (a === null) {

      } else {
        this.estimate.authorisedBy = a.assessor_name
      }
    },
    isNew (id) {
      return _.includes(id, 'new-')
    },
    openRightMenu: function (e, index, part, type) {
      if (this.isAuthorised) {
        return
      }
      if (!this.isStatusActive) {
        return
      }
      let estimateItem = this.$refs[this.selectedEstimateItem.type + '-' + this.selectedEstimateItem.part.id]
      if (estimateItem) {
        estimateItem[0].$el.style.cssText = 'background-color: transparent'
      }
      this.selectedEstimateItem.part = part
      this.selectedEstimateItem.type = type

      this.$refs.rightClickMenuForAuthorisation.open(e, { index: index, part: part, type: type })
    },
    setEstimatePartsCopy () {
      this.estimatePartsBeforeAuthorisation = _.cloneDeep(this.estimateParts)
    },
    setIsChecked () {
      _.forEach(this.availableCards, (c) => {
        this.checkedAll[c] = _.filter(this.getNotAuthorisedParts(this.estimateParts[c]), (p) => {return p.isAuthorized }).length == this.getNotAuthorisedParts(this.estimateParts[c])?.length
      })
    },
    setIsCheckedParts () {
      _.forEach(this.availableCards, (c) => {
        _.forEach(this.getNotAuthorisedParts(this.estimateParts[c]), p => {
          if (p.adj_approve_status == 'approved' || p.adj_approve_status == 'denied' || p.adj_approve_status == 'reported') {
            p.isAuthorized = true
          }
        })
      })
    },
    setRateForAll (card, rate) {
      _.forEach(this.getNotAuthorisedParts(this.estimateParts[card]), p => {
        // p.rate = rate
        p.adj_changed_rate = rate
      })
      this.preAuthorizeCalculation(card)
    },
    approveOrSetNonePart (item, status, isFromContext = false) {
      if (isFromContext && status == 'approved' && (item.adj_approve_status == 'denied' || item.adj_approve_status == 'reported')) {
        if (item.adj_approve_status == 'denied') {
          item.externalComment = ''
          if (item.comments) {
            item.comments.adjComment = ''
          }
          // this.$set(item, 'externalComment', '')
        }
        if (Number(item.adj_rate) == 0) {
          item.adj_rate = item.rate
        }
        if (Number(item.adj_hrs) == 0) {
          item.adj_hrs = item.hrs
        }
      }

      if (status == 'approved') {
        if (!(item.adj_approve_status == 'denied' || item.adj_approve_status == 'reported')) {
          item.adj_approve_status = status
        }
        if (isFromContext) {
          item.isAuthorized = true
          item.adj_approve_status = status
        }
      } else if (status == 'none') {
        item.adj_approve_status = status
      }

      this.setIsChecked()
      this.$refs.rightClickMenuForAuthorisation.close()
    },
    markOnReportOrDecline (itm, status) {
      if (itm?.data?.part) {
        itm.data.part.adj_approve_status = status

        if (itm.data.type == 'Sublet' || itm.data.type == 'Other' || itm.data.type == 'Materials' || itm.data.type == 'Part' ||
            (this.isEstimateMethodologyDollars && (itm.data.type == 'RR' || itm.data.type == 'Repair' || itm.data.type == 'Paint'))) {
          itm.data.part.adj_rate = 0
        } else if (itm.data.type == 'PDR') {
          itm.data.part.adj_price = 0
        } else {
          itm.data.part.adj_rate = null
        }

        itm.data.part.adj_hrs = '0'
        itm.data.part.isAuthorized = true
        this.$refs.rightClickMenuForAuthorisation.close()
        let index = _.findIndex(this.estimateParts[itm.data.type], (p) => {
          return Number(p.id) == Number(itm.data.part.id)
        })

        if (index !== -1) {
          this.$set(this.estimateParts[itm.data.type][index], 'adj_approve_status', status)
          this.$set(this.estimateParts[itm.data.type][index], 'isAuthorized', true)
          // this.$set(this.estimateParts[itm.data.type], index, itm.data.part)

          if (itm.data.type == 'Sublet'
              || itm.data.type == 'Other'
              || itm.data.type == 'Materials'
              || itm.data.type == 'Part'
              ||              (this.isEstimateMethodologyDollars && (itm.data.type == 'RR' || itm.data.type == 'Repair' || itm.data.type == 'Paint'))) {
            this.$set(this.estimateParts[itm.data.type][index], 'adj_rate', 0)
          } else if (itm.data.type == 'PDR') {
            this.$set(this.estimateParts[itm.data.type][index], 'adj_price', 0)
          } else {
            this.$set(this.estimateParts[itm.data.type][index], 'adj_rate', null)
          }

          this.$set(this.estimateParts[itm.data.type][index], 'adj_hrs', '0')
        }
        this.setIsChecked()
        if (itm.data.type == 'Repair' || itm.data.type == 'Paint') {
          this.preAuthorizeCalculation(itm.data.type)
        }
      }
    },
    _isEmpty (v) {
      return _.isEmpty(v)
    },
    getOriginalIndex (parts, id) {
      return _.findIndex(parts, (p) => {
        if (_.includes(id, 'new-')) {
          return p.id == id
        } else {
          return Number(p.id) == Number(id)
        }
      })
    },
    getNotAuthorisedParts (parts) {
      return _.filter(parts, (p) => {
        return !p.addedByAssessor
        // return true
      })
    },
    cancelPage () {
      _.forEach(this.availableCards, (c) => {
        this.checkedAll[c] = false
        // _.forEach(this.getNotAuthorisedParts(this.estimateParts[c]), p => {
        //   if (!p.isAuthorized) {
        //     p.authorizedOn  = null
        //     p.authorizedBy  = null
        //     // p.internalComment  = null
        //     // p.externalComment  = null
        //     // p.adj_approve_status  = 'none'
        //   }
        //
        //   let part = _.find(this.estimatePartsBeforeAuthorisation[c], (prt) => {
        //     return Number(prt.id) == Number(p.id)
        //   })
        //   if (part) {
        //     // p.adj_hrs = part.adj_hrs ? part.adj_hrs : null;
        //     // p.adj_rate = part.adj_rate ? part.adj_rate : null;
        //     p.rate = part.rate ? part.rate : null;
        //   }
        // })
      })
      this.isClickedConfirmAuthorisation = false
      this.$emit('changeEstimateParts', this.estimatePartsBeforeAuthorisation)
      this.$emit('cancelAuthoriseEstimate')
    },
    preAuthorizeCalculation (card) {
      if (card !== 'Paint' && card !== 'Repair') {
        return
      }
      let data = {
        parts: [],
        rates: {}
      }
      _.forEach(['Paint', 'Repair'], (c) => {
        _.forEach(_.cloneDeep(this.getNotAuthorisedParts(this.estimateParts[c])), (p, index) => {
          if (_.includes(p.id, 'new-')) {
            p.id = null
          }
          let obj = {
            id: p.id,
            type: c,
            adjHrs: p.adj_hrs,
            hrs: p.hrs,
            rate: p.rate,
            adjRate: p.adj_rate,
            adj_changed_rate: p.adj_changed_rate,
          }
          if (c == 'Paint') {
            obj.paintType = p.paint_type
          }
          data.parts.push(obj)
        })
      })

      data.adjRates = this.estimate.adjRates

      Axios.post(`/fe/estimate/${this.estimateId}/pre-authorize-calculation`, data)
          .then(response => {
            if (response.data._status && response.data?.Materials) {

              _.forEach(response.data.Materials, (prt) => {
                let partBefore = _.find(this.estimatePartsBeforeAuthorisation.Materials, (p) => {
                  return Number(prt.id) == Number(p.id)
                })
                let partNow = _.find(this.estimateParts.Materials, (p) => {
                  return Number(prt.id) == Number(p.id)
                })
                if (partBefore && partNow) {
                  // if (Number(partBefore.adj_hrs) !== Number(partNow.adj_hrs)) {
                  //   prt.adj_hrs = partNow.adj_hrs
                  // }
                  // if (Number(partBefore.adj_rate) !== Number(partNow.adj_rate)) {
                  //   prt.adj_rate = partNow.adj_rate
                  // }
                  if (Number(partBefore.adj_approve_status) !== Number(partNow.adj_approve_status)) {
                    prt.adj_approve_status = partNow.adj_approve_status
                  }
                  if (Number(partBefore.isAuthorized) !== Number(partNow.isAuthorized)) {
                    prt.isAuthorized = partNow.isAuthorized
                  }
                }
              })

              this.estimateParts.Materials.splice(0, this.estimateParts.Materials.length)
              let vm = this
              setTimeout(() => {
                response.data.Materials.forEach(function (elem) {
                  vm.estimateParts.Materials.push(elem)
                })
                this.setIsChecked()
              }, 0)
              // this.$set(this.estimateParts, 'Materials', response.data.Materials)
            }
          })
          .catch(error => {
            console.log(error)
          })

    },
    cancelAuthority () {
      NProgress.start()
      Axios.post(`/fe/estimate/${this.estimateId}/cancel-authorize`)
          .then(response => {
            if (response.data._status) {
            }
          })
          .catch(error => {
            console.log(error)
          }).finally(() => {
        this.$emit('cancelAuthoriseEstimate')
        this.$emit('confirmedAuth')
        NProgress.done()
      })
      this.$refs.cancelAuthorityModal.hide()
    },
    confirmAuthorisation () {
      this.isClickedConfirmAuthorisation = true

      let isHasError = _.some(this.availableCards, (c) => {
        if (c !== 'MaterialsCalc') {
          return _.some(this.getNotAuthorisedParts(this.estimateParts[c]), (p) => {
            let hrs = _.isNumber(p.hrs) ? _.toString(p.hrs) : p.hrs
            let rate = _.isNumber(p.rate) ? _.toString(p.rate) : p.rate

            if (c == 'Materials') {
              if (p.subtype === 'EnvironmentLevy') {
                hrs = '999'

                if (p.type !== 'calculation') {
                  rate = p.rate
                } else {
                  if (p.rs_rate && p.rs_rate !== null) {
                    rate = p.rs_rate
                  } else {
                    rate = p.rate
                  }
                }
              } else if (p.subtype === 'PaintSetupTime') {
                if (p.type === 'manual') {
                  hrs = p.hrs
                } else {
                  if (p.original_hrs && p.original_hrs !== null) {
                    hrs = p.original_hrs
                  } else if (p.rs_hrs && p.rs_hrs !== null) {
                    hrs = p.rs_hrs
                  } else {
                    hrs = p.hrs
                  }
                }

                if (p.type !== 'calculation') {
                  rate = p.rate
                } else {
                  if (p.rs_rate && p.rs_rate !== null) {
                    rate = p.rs_rate
                  } else {
                    rate = p.rate
                  }
                }
              } else {
                if (p.type === 'manual') {
                  hrs = p.hrs
                } else {
                  if (p.original_hrs && p.original_hrs !== null) {
                    hrs = p.original_hrs
                  } else if (p.rs_hrs && p.rs_hrs !== null) {
                    hrs = p.rs_hrs
                  } else {
                    hrs = p.hrs
                  }
                }

                if (p.type !== 'calculation') {
                  rate = p.rate
                } else {
                  if (p.original_total && p.original_total !== null) {
                    rate = p.original_total
                  } else if (p.rs_rate && p.rs_rate !== null) {
                    rate = p.rs_rate
                  } else {
                    rate = p.rate
                  }
                }
              }

              hrs = _.isNumber(hrs) ? _.toString(hrs) : hrs
              rate = _.isNumber(rate) ? _.toString(rate) : rate
            }
            if (c == 'Other' || c == 'Part' || c == 'Sublet' || (this.isEstimateMethodologyDollars && (c == 'RR' || c == 'Repair' || c == 'Paint'))) {
              hrs = '999'
            }

            return p && ((p.hasOwnProperty('hrs') &&
                ((_.isEmpty(hrs) && !_.isNumber(hrs)) || Number(hrs) == 0)) || (p.hasOwnProperty('rate') && ((_.isEmpty(rate) && !_.isNumber(rate)) || Number(rate) == 0))) && p.isAuthorized && !p?.onReportRepairer?.flag
          })
        } else {
          // console.log('!!!0')
          return false
        }
      })

      if (isHasError) {
        // console.log('!!!1')
        return
      }

      let data = {
        authorizeParts: [],
        addedParts: [],
        authorisedBy: this.estimate.authorisedBy,
        authorisedByCustomer: this.estimate.authorisedByCustomer,
      }

      data.adjRates = this.estimate.adjRates

      if (!_.isEmpty(this.removeEstimateParts)) {
        data.deleteParts = this.removeEstimateParts
      }

      _.forEach(this.availableCards, (c) => {
        _.forEach(_.cloneDeep(this.getNotAuthorisedParts(this.estimateParts[c])), (p, index) => {
          if (_.includes(p.id, 'new-')) {
            p.id = null
            data.addedParts.push(p)
          } else {
            let obj = {
              id: p.id,
              type: c,
              isAuthorized: p.isAuthorized,
              internalComment: p?.comments?.manualComment ? p.comments.manualComment : null,
              externalComment: p.externalComment ? p.externalComment : null,
              manualPdfComment: p?.comments?.manualPdfComment ? p.comments.manualPdfComment : null,
              manualPdfCommentAuthor: p?.comments?.manualPdfCommentAuthor ? p.comments.manualPdfCommentAuthor : null,
              adjStatus: p.adj_approve_status,
            }

            if (c == 'Part') {
              obj.orderPosition = index
            }

            let part = _.find(this.estimatePartsBeforeAuthorisation[c], (prt) => {
              return Number(prt.id) == Number(p.id)
            })

            if (part) {
              if (!_.isEqual(Number(p.adj_rate), Number(part.adj_rate))) {
                obj.adjRate = p.adj_rate
              }
              if (c === 'PDR' && !_.isEqual(Number(p.adj_price), Number(part.adj_price))) {
                obj.adjPrice = p.adj_price
              }
              if (!_.isEqual(Number(p.hrs), Number(part.hrs))) {
                obj.hrs = p.hrs
              }
              if (!_.isEqual(Number(p.rate), Number(part.rate))) {
                obj.rate = p.rate
              }
              if (c === 'PDR' && !_.isEqual(Number(p.price), Number(part.price))) {
                obj.price = p.price
              }
              if (!_.isEqual(Number(p.adj_hrs), Number(part.adj_hrs))) {
                obj.adjHrs = p.adj_hrs
              }
              if (!_.isEqual(p.name, part.name)) {
                obj.change_name = p.name
              }

              if (c == 'Paint') {
                if (!_.isEqual(p.paint_type, part.paint_type)) {
                  obj.change_paint_type = p.paint_type
                }
              }

              if (c == 'PDR') {
                if (!_.isEqual(p.price, part.price)) {
                  obj.change_price = p.price
                }
                if (!_.isEqual(p.qty, part.qty)) {
                  obj.change_qty = p.qty
                }
              }

              if (c == 'Sublet') {
                if (!_.isEqual(p.mup, part.mup)) {
                  obj.change_mup = p.mup
                }
                if (!_.isEqual(p.repairer, part.repairer)) {
                  obj.change_repairer = p.repairer
                }
              }

              if (c == 'Part') {
                if (!_.isEqual(p.type, part.type)) {
                  obj.change_part_type = p.type
                }
                if (!_.isEqual(Number(p.qty), Number(part.qty))) {
                  obj.change_qty = p.qty
                }
                if (!_.isEqual(Number(p.mup), Number(part.mup))) {
                  obj.change_mup = p.mup
                }
                if (!_.isEqual(Number(p.cost), Number(part.cost))) {
                  obj.change_cost = p.cost
                }
                if (!_.isEqual(p.name, part.name)) {
                  obj.change_name = p.name
                }
                if (!_.isEqual(p.part_num, part.part_num)) {
                  obj.change_part_num = p.part_num
                }
              }
            }
            if (obj.adjStatus == 'denied') {
              obj.adjRate = 0
              obj.adjHrs = 0
            }
            if (obj.adjStatus == 'reported') {
              obj.adjRate = null
              obj.adjHrs = null
            }

            data.authorizeParts.push(obj)
          }
        })
      })
      NProgress.start()
      Axios.post(`/fe/estimate/${this.estimateId}/authorize`, data)
          .then(response => {
            if (response.data._status) {
            }
          })
          .catch(error => {
            console.log(error)
          }).finally(() => {
        this.isClickedConfirmAuthorisation = false
        this.$emit('cancelAuthoriseEstimate')
        this.$emit('confirmedAuth')
        NProgress.done()
      })
    },
    calculatedTotalByCard (card) {
      let a = 0
      for (let i = 0; i < this.estimateParts[card].length; i++) {
        let item = this.estimateParts[card][i]

        if (!item) {
          continue
        }

        switch (card) {
          case 'Paint':
          case 'Repair':
          case 'RR':
            if (item.isSupplementDeletion) {
              break
            }
            if (this.isEstimateMethodologyDollars) {
              a += this.pT(item.rate)
              break
            }
            a += this.pT(item.hrs * item.rs_rate)
            // if (item.total_manual != null) {
            //   a += this.pT(item.total_manual)
            //   break
            // }
            // a += this.pT(item.total)
            break
          case 'Material':
          case 'Materials':
            if (item) {
              if (item.type === 'calculation' && item.original_total) {
                a += this.pT(item.original_total)
              } else if (item.type === 'calculation' && item.rs_rate) {
                a += this.pT(item.rs_rate)
              } else {
                a += this.pT(item.rate)
              }
            }
            break
          case 'Part':
          case 'Sublet':
          case 'PDR':
            if (item.isSupplementDeletion) {
              break
            }
            a += this.pT(item.price * item.qty)
            break
          case 'Other':
            if (item.isSupplementDeletion) {
              break
            }
            a += this.pT(item.rate)
            break
        }

      }
      return a
    },
    calculatedAdjTotalByCard (card) {
      let a = 0
      for (let i = 0; i < this.estimateParts[card].length; i++) {
        let item = this.estimateParts[card][i]
        if (item.adj_approve_status == 'reported' || item?.adj_approve_status == 'denied') {
          continue
        }
        switch (card) {
          case 'Paint':
          case 'Repair':
          case 'RR':
            if (item.isSupplementDeletion) {
              break
            }
            if (this.isEstimateMethodologyDollars) {
              a += item.adj_rate != null ? this.pT(item.adj_rate) : this.pT(item.rate)
              break
            }
            if (item.adj_rate !== null && item.adj_rate !== undefined && item.adj_rate !== '' && card !== 'Paint') {
              a += this.pT(item.adj_rate)
              break
            }
            a += this.pT(this.pT(item.adj_hrs || item.hrs) * this.pT(item.adj_changed_rate))
            // if (item.adj_hrs != null) {
            //   a += this.pT(this.pT(item.adj_hrs) * this.pT(item.adj_changed_rate))
            //   break
            // }
            // if (item.total_manual != null) {
            //   a += this.pT(item.total_manual)
            //   break
            // }
            // a += this.pT(item.total)
            break
          case 'Part':
            if (item.isSupplementDeletion) {
              break
            }
            if (item.adj_rate != null) {
              a += this.pT(item.adj_rate)
            } else {
              a += this.pT(item.total)
            }
            break
          case 'Material':
          case 'Materials':
            let isUseCalcValue = false
            if ((this.properties.isFromEio || this.properties.isFromIag) && item.type == 'calculation') {
              let r = 0
              if (item.adj_rate && item.original_total && item.adj_rate == item.original_total) {
                r = 0
              } else if (item.adj_rate) {
                r = item.adj_rate
              } else if (item.original_total) {
                r = item.original_total
              }
              if (r) {
                isUseCalcValue = true
                a += this.pT(r)
              }
            }

            if (!isUseCalcValue) {
              let adj_rate = item.adj_rate
              if (item.subtype !== 'EnvironmentLevy') {
                let hrs = null
                if (item.type === 'manual') {
                  hrs = item.hrs
                } else {
                  if (item.original_hrs && item.original_hrs !== null) {
                    hrs = item.original_hrs
                  } else if (item.rs_hrs && item.rs_hrs !== null) {
                    hrs = item.rs_hrs
                  } else {
                    hrs = item.hrs
                  }
                }
                let rate = item.material_rate

                if (item.adj_hrs == null) {
                  adj_rate = null
                } else if (item.adj_hrs == 0) {
                  adj_rate = 0
                } else if (hrs != '' && hrs != null) {
                  adj_rate = accounting.toFixed(rate * item.adj_hrs, 2)
                }
              }

              if (item.subtype == 'PaintSetupTime' && item.adj_hrs == null && item.adj_rate !== null) {
                adj_rate = item.adj_rate
              }

              if (adj_rate !== null && adj_rate !== undefined && adj_rate !== '' && !isNaN(parseFloat(adj_rate))) {
                a += this.pT(adj_rate)
              } else if (item.original_total !== null && item.original_total !== undefined && item.original_total !== '' && !isNaN(parseFloat(item.original_total))) {
                // console.log('original_total', this.pT(item.original_total))
                a += this.pT(item.original_total)
              } else if (item.rs_rate !== null && item.rs_rate !== undefined && item.rs_rate !== '' && !isNaN(parseFloat(item.rs_rate))) {
                // console.log('rs_rate', this.pT(item.rs_rate))
                a += this.pT(item.rs_rate)
              } else if (!isNaN(parseFloat(item.rate))) {
                // console.log('rate', this.pT(item.rate))
                a += this.pT(item.rate)
              } else {
                // console.log('NON')
              }
            }
            break
          case 'PDR':
            if (item.isSupplementDeletion) {
              break
            }
            if (item.adj_price !== null && item.adj_price !== undefined && item.adj_price !== '') {
              a += this.pT(item.adj_price)
            } else {
              a += this.pT(this.pT(item.price) * this.pT(item.qty))
            }
            break
          case 'Other':
            if (item.isSupplementDeletion) {
              break
            }
            a += item.adj_rate != null ? this.pT(item.adj_rate) : this.pT(item.rate)
            break
          case 'Sublet':
            if (item.isSupplementDeletion) {
              break
            }
            a += item.adj_rate != null ? this.pT(item.adj_rate) : this.pT(item.total)
            break
        }
      }
      return a
    },
    calculatedAdjTotalPercentByCard (card) {
      if (this.calculatedTotalByCard(card) == 0) {
        return 0
      }
      if (this.calculatedAdjTotalByCard(card) > this.calculatedTotalByCard(card)) {
        let result = accounting.toFixed(-(1 - this.calculatedAdjTotalByCard(card) / this.calculatedTotalByCard(card)) * 100, 2)
        if (result > 0) {
          return '+' + result
        } else {
          return '+' + (-1 * result)
        }
      }
      let result = accounting.toFixed((1 - this.calculatedAdjTotalByCard(card) / this.calculatedTotalByCard(card)) * 100, 2)
      if (result > 0) {
        return '-' + result
      } else {
        return result
      }
    },
    checkAll (card, v) {
      _.forEach(this.getNotAuthorisedParts(this.estimateParts[card]), (p, ind) => {
        if (v) {
          this.approveOrSetNonePart(p, 'approved')
          // p.adj_approve_status = 'approved'
        } else {
          // p.adj_approve_status = 'none'
          this.approveOrSetNonePart(p, 'none')
        }
        p.isAuthorized = v
      })
      this.setIsChecked()
    },
    checkedItems (card, id, v) {
      let ind = _.findIndex(this.estimateParts[card], (p) => {
        return Number(p.id) == Number(id)
      })
      if (ind !== -1) {
        this.estimateParts[card][ind].isAuthorized = v
        if (v) {
          this.approveOrSetNonePart(this.estimateParts[card][ind], 'approved')
          // this.estimateParts[card][ind].adj_approve_status = 'approved'
        } else {
          this.approveOrSetNonePart(this.estimateParts[card][ind], 'none')
        }
      }
      this.checkedAll[card] = _.filter(this.getNotAuthorisedParts(this.estimateParts[card]), (p) => {return p.isAuthorized }).length == this.getNotAuthorisedParts(this.estimateParts[card])?.length
    },
    pT (value) {
      return parseFloat(accounting.toFixed(parseFloat(value), 2))
    },

    removeEstimatePart (card, index, isFromModal = false) {
      if (!this.isStatusActive) {
        return
      }
      if (isFromModal) {
        this.$refs.deleteConfirmModal.hide()
      }
      let part = this.estimateParts[card][index]
      if (!isFromModal && part?.id && (part?.adj_approve_status == 'reported' || part?.adj_approve_status == 'approved' || part?.adj_approve_status == 'denied' || part?.addedByAssessor)) {
        this.currentPartForRemoving = {
          card: card,
          index: index,
        }
        this.$refs.deleteConfirmModal.show()
        return
      }

      if (this.estimateParts[card][index].id != null) {
        this.removeEstimateParts.push({
          id: this.estimateParts[card][index].id,
          type: card,
        })
      }
      var vm = this
      setTimeout(() => {
        vm.estimateParts[card].splice(index, 1)
      }, 100)

      if (card == 'Repair' || card == 'Paint') {
        this.preAuthorizeCalculation(card)
      }
    },

    closeContext () {
      let estimateItem = this.$refs[this.selectedEstimateItem.type + '-' + this.selectedEstimateItem.part.id]
      estimateItem[0].$el.style.cssText = 'background-color: transparent'
      this.selectedEstimateItem.type = ''
      this.selectedEstimateItem.part = {}
      if (this.currentManualItemComment) {
        this.currentManualItemComment = ''
      }
      if (this.currentEstimateItemComment) {
        this.currentEstimateItemComment = ''
      }
    },
    openContext () {
      let estimateItem = this.$refs[this.selectedEstimateItem.type + '-' + this.selectedEstimateItem.part.id]
      estimateItem[0].$el.style.cssText = 'background-color: #F9F9F9'
    },
    onKeyPress: function (event) {
      if (!this.isStatusActive) {
        return
      }
      this.$emit('beforeDebouncedUnsavedChanges')
    },
    onRightLeftKeyPress: function (index, partId, fieldName, card) {
      let id = card + '-' + partId
      console.log(id, fieldName, this.$refs[id][0])
      this.$nextTick(() => {
        this.$refs[id][0].getFocus(fieldName)
      })
    },
    onRightKeyPress: function (index, partId, fieldName, card) {
      this.onRightLeftKeyPress(index, partId, fieldName, card)
    },
    onLeftKeyPress: function (index, partId, fieldName, card) {
      this.onRightLeftKeyPress(index, partId, fieldName, card)
    },
    onUpKeyPress: function (partId, isAuthorisedMode, fieldName, card) {
      let estimateParts = isAuthorisedMode ? this.getNotAuthorisedParts(this.estimateParts[card]) : this.estimateParts[card]
      let maxParts = estimateParts.length

      let part = _.find(estimateParts, (p) => {
        return p.id === partId
      })

      let index = estimateParts.indexOf(part)

      index -= 1

      let cardIndex = this.availableCards.indexOf(card)
      if (index < 0) {
        if (cardIndex == 0) {
          cardIndex = this.availableCards.length - 1
        } else {
          cardIndex -= 1
        }

        fieldName = this.availableCards[cardIndex] + '-name'
        index = this.getNotAuthorisedParts(this.estimateParts[this.availableCards[cardIndex]]).length - 1

        if (this.availableCards[cardIndex] == 'Materials') {
          fieldName = this.availableCards[cardIndex] + '-adj_hrs'
          if (this.getNotAuthorisedParts(this.estimateParts[this.availableCards[cardIndex]]).at(-1).subtype == 'EnvironmentLevy') {
            index -= 1
          }
        }

        // index = maxParts - 1
      }

      let id = this.availableCards[cardIndex] + '-' + this.getNotAuthorisedParts(this.estimateParts[this.availableCards[cardIndex]])[index].id
      this.$nextTick(() => {
        this.$refs[id][0].getFocus(fieldName, true)
      })

    },
    onDownKeyPress: function (partId, isAuthorisedMode, fieldName, card) {
      let estimateParts = isAuthorisedMode ? this.getNotAuthorisedParts(this.estimateParts[card]) : this.estimateParts[card]
      let maxParts = estimateParts.length

      let part = _.find(estimateParts, (p) => {
        return p.id === partId
      })

      let index = estimateParts.indexOf(part)

      index += 1

      let cardIndex = this.availableCards.indexOf(card)
      if (index >= maxParts) {
        if (cardIndex == this.availableCards.length - 1) {
          cardIndex = 0
        } else {
          cardIndex += 1
        }

        fieldName = this.availableCards[cardIndex] + '-name'

        if (this.availableCards[cardIndex] == 'Materials') {
          fieldName = this.availableCards[cardIndex] + '-adj_hrs'
        }

        index = 0
      }

      let id = this.availableCards[cardIndex] + '-' + this.getNotAuthorisedParts(this.estimateParts[this.availableCards[cardIndex]])[index].id
      console.log(fieldName, id)
      this.$nextTick(() => {
        this.$refs[id][0].getFocus(fieldName, true)
      })
    },
    onEnterKeyPress: function (partId, index, ind, card) {
      this.selectCardSubPart('', card, index)
    },
    selectCardSubPart: function (sp, card, index) {
      if (!this.isStatusActive || this.isAuthorised) {
        return
      }

      this.selectedCardSubPart = null
      let id = ''

      var default_rate = 0
      var default_paint_type = 'not_set'

      if (card === 'RR') {
        default_rate = this.estimate.adjRates?.rr ? this.estimate.adjRates.rr : this.estimateRates.rr
      } else if (card === 'Paint') {
        default_rate = this.estimate.adjRates?.paint ? this.estimate.adjRates.paint : this.estimateRates.paint
        default_paint_type = this.estimateRates.paint_material

      } else if (card === 'Repair') {
        default_rate = this.estimate.adjRates?.repair ? this.estimate.adjRates.repair : this.estimateRates.repair
      }

      if (card == 'Part') {
        var newItem = {
          id: null,
          adj_price: null,
          adj_rate: null,
          adj_mup: null,
          name: sp.prt,
          part_num: '',
          type: 'New',
          mup: 0,
          qty: 1,
          rate: 0,
          rate2: 0,
          total: 0,
          is_show_in_jobcard: true,
          comments: {},
        }

      } else if (card == 'Paint') {
        //console.log('sp');
        // console.log(sp);
        if (this.isEstimateMethodologyCustom) {
          var t_hours = sp.hrs
        } else {
          if (this.rates.paint_material == 'S1') {
            var t_hours = sp.S1
          } else if (this.rates.paint_material == 'S2') {
            var t_hours = sp.S2
          } else if (this.rates.paint_material == 'M1') {
            var t_hours = sp.M1
          } else if (this.rates.paint_material == 'M2') {
            var t_hours = sp.M2
          } else if (this.rates.paint_material == 'M3') {
            var t_hours = sp.M3
          } else if (this.rates.paint_material == 'M3PLUS') {
            var t_hours = sp.M3PLUS
          } else {
            var t_hours = sp.hrs
          }
        }
        if (sp.hasOwnProperty('total_manual')) {
          var newItem = {
            id: null,
            storage_item_id: sp.id,
            name: sp.prt,
            paint_type: sp.paint_type,
            hrs: sp.hrs,
            rate: default_rate,
            adj_changed_rate: default_rate,
            rate2: 0,
            total: 0,
            total_manual: sp.total_manual,
            is_show_in_jobcard: true,
            comments: {},
            adj_price: null,
            adj_rate: null,
            adj_hrs: null,

          }
        } else {
          var newItem = {
            id: null,
            storage_item_id: sp.id,
            name: sp.prt,
            paint_type: this.rates.paint_material,
            hrs: t_hours,
            rate: default_rate,
            adj_changed_rate: default_rate,
            rate2: 0,
            total: 0,
            total_manual: sp.total_manual,
            is_show_in_jobcard: true,
            comments: {},
            adj_price: null,
            adj_rate: null,
            adj_hrs: null,
          }
        }
      } else if (card == 'Sublet') {
        var newItem = {
          id: null,
          name: sp.prt,
          repairer: '',
          hrs: 0,
          rate: 0,
          total: 0,
          adj_price: null,
          adj_rate: null,
          adj_mup: null,
          is_show_in_jobcard: true,
          comments: {},
        }
      } else if (card == 'Materials') {
        var newItem = {
          id: null,
          name: sp.prt,
          type: 'manual',
          hrs: 0,
          rate: 0,
          total: 0,
          adj_hrs: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          comments: {},
        }
      } else if (card === 'PDR') {
        var newItem = {
          id: null,
          type: sp.type,
          name: '',
          material: 'None',
          action: 'None',
          qty: 1,
          price: 0,
          total: 0,
          comment: '',
          adj_price: null,
          is_show_in_jobcard: true,
          comments: {},
        }
      } else if (card === 'RR' && sp.hasOwnProperty('createdOn')) {
        var newItem = {
          id: null,
          name: sp.name,
          rate: default_rate,
          rate2: 0,
          hrs: sp.hours,
          total: 0,
          total_manual: sp.total,
          adj_hrs: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          comments: {},
        }
      } else {
        //Всё остальное
        var newItem = {}
        //console.log('SP!', sp);
        if (sp.hasOwnProperty('total_manual')) {
          newItem = {
            id: null,
            name: sp.prt,
            rate: sp.rate || default_rate,
            rate2: 0,
            hrs: sp.hrs,
            total: 0,
            total_manual: sp.total_manual,
            adj_hrs: null,
            adj_rate: null,
            is_show_in_jobcard: true,
            comments: {},
          }
        } else {
          newItem = {
            id: null,
            name: sp.prt,
            rate: sp.total || default_rate,
            rate2: 0,
            hrs: sp.hrs,
            total: 0,
            total_manual: sp.total_manual,
            adj_hrs: null,
            adj_rate: null,
            is_show_in_jobcard: true,
            comments: {},
          }
        }
        if ((card === 'RR') || (card === 'Paint') || (card === 'Repair')) {
          newItem.rate = default_rate
          newItem.adj_changed_rate = default_rate
        }
      }

      if (this.isRSEstimateMethodology) {
        //console.log('if1');
        if (['RR', 'Repair', 'Paint'].includes(card)) {
          newItem.hrs = parseFloat(accounting.toFixed(newItem.hrs * 1.2, 2))
        }
      }

      let id2 = 'new-' + Math.floor(Math.random() * 1000)
      newItem.id = id2
      this.estimateParts[card].splice(index + 1, 0, newItem)
    },
  },
  components: {
    EstimateItem,
    NumberFormatter,
    VueContext,
    RsRipple,
    datePicker,
    draggable,
    AdvancedSearch
  }

}
</script>

<style>
.V3 .estimates-edit .assessment-auth-page label.checkbox > input[type="checkbox"]:checked:disabled + span.icon i {
  color: white;
}

.V3 .estimates-edit .assessment-auth-page label.checkbox > input[type="checkbox"]:checked:disabled + span.icon {
  background-color: #5E79FF;
}

.V3 .estimates-edit label.checkbox > input[type="checkbox"]:disabled + span.icon:hover {
  cursor: not-allowed;
}


.V3 .estimates-edit .mr-15px {
  margin-right: 15px !important;
}

.estimates-edit .estimate-items.disabled-draggable .qtit:hover {
  cursor: default;
}

.estimates-edit .estimate-items.disabled-draggable .selected-row {
  border-top: none !important;
  border-right: none !important;
  border-left: none !important;
  box-shadow: none !important;
  border-radius: 0px !important;
  border-bottom: 1px solid rgba(27, 30, 56, .25) !important;
}
</style>

<style scoped>
.estimate-item-list {
  overflow-x: auto;
  height: calc(100vh - 325px);
  width: calc(100vw - 230px);
  max-width: 1150px;
  scrollbar-width: thin;
}

.V3.compact-sidebar .estimate-item-list {
  width: calc(100vw - 80px);
}

.checkbox-part-margin-left {
  margin-left: 0 !important;
}

.btn-disabled:disabled:hover {
  background-color: #5E79FF;
}

.modal-cancel-authority {
  display: block;
}

.assessment-assessor-name-input.active >>> .form-control {
  background-color: #f0f0f0 !important;
}

.assessment-assessor-name-input >>> .register-adv-search-block .form-control {
  padding-right: 30px;
}

.assessment-assessor-name-input >>> .text-grey {
  right: 7px !important;
}

.assessment-assessor-name-input {
  position: relative;
}

.assessment-assessor-name {
  margin-right: 50px !important;
}

.assessment-assessor-name-title {
  margin-right: 10px;
}

.form-check-inline.checkbox {
  margin-left: 4px;
}

.date-picker-max-width-100px >>> .form-control {
  max-width: 100px;
}

.h-66px {
  height: 66px !important;
}

.autorise-estimate-table {
  /*margin-bottom: 50px;*/
  scrollbar-width: thin;
}

.part-table-min-width {
  min-width: 1110px;
}

.pdr-table-min-width {
  min-width: 1010px;
}

.paint-table-min-width {
  min-width: 920px;
}

.others-table-min-width {
  min-width: 870px;
}

.authorise-estimate-header {
  margin-bottom: 15px;
}

.authorise-estimate-header button {
  margin-right: 15px;
  padding: 7px 15px;
}

.authorise-estimate-title {
  font-weight: 700;
  font-size: 14px;
  margin: 5px 20px;
}

.authorise-estimate-cancel {
  background-color: #fdfdfd;
  color: #5d78fd;
}

.authorise-estimate-cancel:hover {
  background-color: #fdfdfd;
}

.comment-fixed-position {
  top: -88px !important;
}

.gray-background {
  background-color: #f9f9f9 !important;
}

.selected-group {
  color: #000000 !important;
}

.border-top-groups {
  border-top: 1px solid rgba(0, 0, 0, 0.25);
}

.border-bottom-groups {
  border-bottom: 1px solid rgba(0, 0, 0, 0.25);
}

.new-estimate-group-item {
  padding: 1rem 0.5rem 1rem 1.5rem;
  border: none;
  max-width: 77%;
}

.estimate-group-item {
  border-top: 1px solid rgba(0, 0, 0, 0.25);
  cursor: pointer;
}

.estimate-group-item:hover {
  background-color: #F9F9F9;
  cursor: pointer;
}

.estimate-group-item:hover .estimate-group-item-input {
  background-color: #F9F9F9;
  cursor: pointer;
}

.estimate-group-item-input {
  width: 78%;
  padding: 1rem 0.5rem 1rem 1.5rem;
  border: none;
  color: #777777;
}

.estimate-group-subitem-input {
  padding-right: 10px;
  border: none;
  width: 100%;
  color: #777777;
}

.estimate-group-sub-item {
  border-left: 1px solid rgba(0, 0, 0, 0.25);
  /*margin-left: 10%;*/
  list-style: none;
  padding: 1rem 0.5rem 1rem 1rem;
  cursor: pointer;
}

.estimate-group-sub-item:hover {
  background-color: #F9F9F9;
  cursor: pointer;
}

.estimate-group-sub-item:hover .estimate-group-subitem-input {
  background-color: #F9F9F9;
  cursor: pointer;
}

.right-col {
  margin-top: 5px;
  margin-right: 8px;
}

@media (max-width: 1500px) {
  .right-col {
    margin-top: 15px;
  }
}

.tabs-absolute-right {
  display: inline-flex;
  margin-right: 30px;
}

.tabs-absolute-right-notes-btn {
  margin-right: 160px;
}

.tab-content {
  padding: 10px 0;
}

.color-dark-grey {
  color: #3F3F3F !important
}

.fz16 {
  font-size: 16px !important
}

.w50 {
  width: 50%
}

.vat {
  vertical-align: top
}

.m0 {
  margin: 0 !important
}

.border-b {
  border-bottom: 1px solid silver !important
}

.border-t {
  border-top: 1px solid silver !important
}

.bg-white {
  background: #FFFFFF !important
}

.th-fz12 th {
  font-size: 12px !important
}

.invoice {
  width: 820px;
  margin: 25px auto
}

.invoice-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.invoice .main-table {
  margin: 0 0 20px;
  width: 100%;
  border-collapse: collapse
}

.invoice .main-table tr.empty-row td, .invoice .main-table tr.empty-row th {
  height: 20px
}

.invoice .main-table .vehicle-details {
  width: 100%
}

.invoice .parts-required {
  margin-bottom: 0
}

.invoice .parts-required td:nth-child(1), .invoice .parts-required th:nth-child(1) {
  width: 355px
}

.invoice .parts-required td:last-child, .invoice .parts-required th:last-child {
  width: 70px
}

.invoice .estimate-repairs td:first-child, .invoice .estimate-repairs th:first-child {
  width: 550px
}

.invoice .estimate-repairs td:nth-child(2), .invoice .estimate-repairs th:nth-child(2) {
  width: 55px
}

.invoice .estimate-repairs td:last-child, .invoice .estimate-repairs th:last-child {
  width: 70px
}

.invoice .estimate-other td:first-child, .invoice .estimate-other th:first-child {
  width: 550px
}

.invoice .estimate-other td:nth-child(2), .invoice .estimate-other th:nth-child(2) {
  width: 55px
}

.invoice .estimate-other td:last-child, .invoice .estimate-other th:last-child {
  width: 70px
}

.invoice .estimate-sublet td:first-child,
.invoice .estimate-sublet th:first-child,
.invoice .estimate-pdr th:first-child {
  width: 605px
}

.invoice .estimate-sublet td:last-child,
.invoice .estimate-sublet th:last-child {
  width: 70px
}

.invoice .estimate-parts td:first-child, .invoice .estimate-parts th:first-child {
  width: 400px
}

.invoice .estimate-parts td:nth-child(2), .invoice .estimate-parts th:nth-child(2) {
  width: 150px
}

.invoice .estimate-parts td:nth-child(3), .invoice .estimate-parts th:nth-child(3) {
  width: 55px
}

.invoice .estimate-parts td:last-child, .invoice .estimate-parts th:last-child {
  width: 70px
}

.invoice .estimate-pdr th:first-child {
  width: 605px
}

.invoice .estimate-pdr th:nth-child(2),
.invoice .estimate-pdr th:nth-child(3) {
  width: 9rem;
}

.invoice .estimate-pdr th:nth-child(5),
.invoice .estimate-pdr th:last-child {
  width: 86px;
}

.invoice .parts-total td:last-child {
  width: 70px;
  padding-left: 15px
}

.invoice .tax-subtotal-hrs td:first-child {
  width: 560px
}

footer {
  clear: both
}

.footer-table {
  width: 100%;
  border-top: 1px solid silver;
  border-bottom: 1px solid silver
}

.footer-table td, .footer-table th {
  text-align: left
}

.footer-table th {
  padding: 16px 8px 10px;
  font-size: 12px
}

.footer-table td {
  padding: 0 8px 16px;
  font-size: 11px;
  color: #595959
}

#parts-details {
  margin-top: -11px;
}

#parts-details .btn-outline-primary:hover {
  background-color: #E0EAF6;
  color: #0275D8;
}

#parts-details .btn-outline-primary.active:hover {
  background-color: #3E70C9;
}

.timeline {
  padding-left: 15px;
}

.V3 .estimates-edit .dropzoneContainer {
  margin: 5px 15px;
  width: auto;
  border: 1px dashed rgba(27, 30, 56, 0.25);
  border-radius: 3px;
  background: white !important;
  min-width: 125px;
}

.V3 .estimates-edit .dropify-wrapper .dropify-message span.file-icon:before {
  content: '\E800';
  font-weight: 800;
  font-size: 37px;
  color: #5E79FF;
}

.V3 .estimates-edit .dropify-wrapper .dropify-message .drop-down-text {
  font-family: "Nunito Sans";
  color: #1C1F39;
  font-size: 13px;
  font-weight: bold;
}

.btnNotBorder {
  border-color: #FAFAFA !important;
}

.btnNotBorder:hover {
  background-color: #FAFAFA !important;
  color: #142742 !important;
}

.btnNotBorder .fa-sort-down {
  left: unset !important;
  margin: 0 !important;
  top: 5px !important;
  font-size: 14px !important;
  width: 20px !important;
  height: auto !important;
}

.dropdownLinks-container {
  flex-direction: column;
  position: absolute;
  border: none;
  background-color: #FAFAFA;
  right: 20px;
  top: 28px;
  height: auto;
  padding: 0;
  margin: 0;
}

.dropdownLinks-links {
  position: relative;
  background: white;
  border: 1px solid #B8B8B8;
}

.dropdownLinks-links:after,
.dropdownLinks-links:before {
  bottom: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.dropdownLinks-links:after {
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #FFFFFF;
  border-width: 5px;
  right: 12px;
  background-clip: padding-box;
}

.dropdownLinks-links:before {
  border-color: rgba(184, 184, 184, 0);
  border-bottom-color: #B8B8B8;
  border-width: 6px;
  right: 11px;
  background-clip: padding-box;
}

.activtyPopupIcon {
  position: unset !important;
  margin: 0 !important;
  font-size: 10px !important;
}

.box-block-grey {
  background: #F1F1F1;
}

.select-parts-check-all {
  font-weight: 500;
  margin-top: 8px;
}

.select-parts-check-all input {
  transform: translateX(calc(50% + 2px));
}

.select-parts-check-all label {
  transform: translateX(8px);
}

#SelectImages4 {
  background: #F1F1F1;
  margin-top: -15px;
  margin-bottom: 30px;
}

.vertical-top {
  vertical-align: top;
}

.vertical-middle {
  vertical-align: middle;
}

.autosave {
  color: #142742;
  font-size: 13px;
  margin-left: 100px;
}

.vue-form-wizard.xs {
  padding-bottom: 0px !important;
  overflow: auto;
}

.wizard-nav {
  overflow: hidden;
}

.vue-form-wizard .wizard-nav-pills a, .vue-form-wizard .wizard-nav-pills li {
  max-width: 89px;
}

.vue-form-wizard .wizard-nav-pills {
  flex-wrap: nowrap;
}

.vue-form-wizard.xs .wizard-icon-circle {
  width: 30px !important;
  height: 30px !important;
}

#activity .wizard-progress-with-circle {
  background-color: rgba(27, 30, 56, 0.12);
  border-radius: 5px;
  /* to keep border radius */
  overflow: hidden;
}

#activity .wizard-icon-circle {
  border: 2px solid #DCDCDC;
}

#activity .active .wizard-icon-circle {
  background: #142742;
}

#activity .wizard-icon-circle ~ .stepTitle {
  color: #B9B9B9;
}

#activity .vue-form-wizard .wizard-tab-content {
  min-height: 1px;
  padding-bottom: 0;
  border-top: 1px solid transparent;
  margin-top: 0px;
  padding: 5px;
}


.wizard-icon.ti-check {
  font-weight: bold;
}

.vue-form-wizard.xs .wizard-navigation .wizard-progress-with-circle {
  height: 2px !important;
  top: 19px !important;
}

.vue-form-wizard.xs .wizard-nav-pills > li.active > a .wizard-icon {
  font-size: 12px !important;
  color: #5E79FF;
}

.wizard-navigation {
  overflow-x: auto;
}

#activity .wizard-navigation {
  float: left;
  margin-top: 18px;
  margin-left: 0;
}

.vue-form-wizard .wizard-icon-circle .wizard-icon-container {
  border-radius: 50%;
}

#activity .vue-form-wizard .wizard-header {
  padding: 15px 30px;
  padding-bottom: 0px;
}

#activity .wizard-icon-circle ~ .stepTitle {
  font-size: 12px;
  font-weight: 600;
  padding: 5px 38px;
}

.card-block {
  position: relative;
}

.tabs-absolute-right {
  display: inline-flex;
  margin-right: 10px;
}

@media screen and (max-width: 1115px) {
  .estimate-item-list {
    height: calc(100vh - 340px);
  }
}

@media screen and (max-width: 991px) {
  .tabs-absolute-right {
    position: relative;
    top: 0px;
    right: 0;
    z-index: 99;
    float: left;
  }
}

.styled-tabs {
  width: 302px;
  border: 1px solid #142742;
  border-radius: 3px;
}

.styled-tabs .nav-link {
  width: 150px;
  text-align: center;
  border: none;
  color: #142742;
  font-size: 14px;
  font-weight: bold;
  padding: 0.3em 0;
}

.styled-tabs .nav-item .active {
  background: #142742;
  color: #FFFFFF;
}

.styled-tabs .nav-item .active:focus {
  background: #142742;
  color: #FFFFFF;
}

.slide-fade-enter-active {
  transition: all .2s ease;
}

.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(-10px);
  opacity: 0;
}

table.main-total-table td.right {
  text-align: right;
}

.estimate_amount {
  border: 1px solid rgba(0, 0, 0, .125);
}

.header_estim_amount h4 {
  width: 60%;
  margin-bottom: 0px;
}

.header_estim_amount h4.amountValue {
  width: 40%;
  margin-bottom: 0px;
}

.header_estim_amount {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 10px;
  border-bottom: 1px solid rgba(0, 0, 0, .125);
}

.body_estim_amount {
  padding: 0 10px;
}

.body_estim_amount > ul > li > span:first-child {
  width: 60%;
}

.body_estim_amount > ul > li > span:last-child {
  width: 40%;
}

.body_estim_amount > ul > li {
  display: flex;
  padding: 5px 0;
  justify-content: space-between;
  align-items: center;
}

.body_estim_amount > ul {
  margin-bottom: 0;
  padding: 0;
}

.filterAssigned:before {
  top: -19px;
  border-color: transparent transparent transparent #BDBDBD;
  border-width: 9px;
  left: 30px;
}

.filterAssigned:after {
  top: -18px;
  border-color: transparent transparent transparent #FFFFFF;
  border-width: 9px;
  left: 30px;
}

.filterAssigned:after, .filterAssigned:before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  transform: rotate(-90deg);
}

.saveAsTemplateList li {
  border-bottom: none !important;
}

.addTemplateList li {
  border-bottom: none !important;
}

.tabs-component ul > li .loaderAssignTo {
  position: absolute;
  max-width: 30px;
  top: 5px;
  right: -36px;
}

.tabs-component ul > li {
  position: relative;
}

.searchInput {
  width: calc(100% - 20px);
}

.filterAssigned > input {
  border: 1px solid rgba(27, 30, 56, .25);
  padding: 2px 7px;
  /*added*/
  margin: 0px 7px;
  width: 90% !important;
  border-radius: 5px;
}

.filterAssigned > ul > li {
  padding: 5px 10px;
  cursor: pointer;
  font-weight: bold !important;

}

.filterAssigned > ul > li:hover {
  background-color: rgba(94, 121, 255, 0.1) !important;
  color: #5E79FF !important;
  border-bottom: 1px solid transparent;
  font-weight: bold !important;
}

.li-in-save-as-template:hover {
  background-color: rgba(94, 121, 255, 0.1) !important;
  color: #5E79FF !important;
}

.filterAssigned > ul {
  padding: 0;
  height: auto;
  max-height: 300px;
  overflow: auto;
  margin-top: 4px;
}

.filterAssigned {
  position: absolute;
  left: 0;
  z-index: 9999;
  background-color: #FFFFFF;
  border: 1px solid #BDBDBD;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  padding: 5px 0px;
  transition: 0.4s;
  top: 100%;
  transform: translateY(10px);
  opacity: 0;
  visibility: hidden;
  width: auto;
  min-width: 190px;
  max-width: 300px;
}

.context-level {
  width: 100% !important;
  left: calc(100% + 1px) !important;
}

.openFilterAssigned {
  opacity: 1;
  visibility: visible;
  transform: translateY(0px);
}

.V3 .tab-pane {
  background: white;
}

.V3 .container-fluid .row .col-md-3 {
  padding: 0px !important;
}

.V3 .container-fluid .row .col-md-9 {
  padding: 0px !important;
}

.V3 .template-tabs.mt-2 .nav-tabs.nav-tabs-2:first {
  margin-bottom: 0px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
}

.V3 ul.nav.nav-4 {
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  margin-right: 10px;
  scrollbar-width: thin;
}

.V3 ul.nav.nav-4 li {
  position: relative;
}

.V3 ul.nav.nav-4 .nav-item.active {
  background-color: rgba(94, 121, 255, 0.1) !important;
}

.V3 ul.nav.nav-4 .nav-item.active a:focus {
  background-color: rgba(94, 121, 255, 0.1) !important;
}

.V3 ul.nav.nav-4 .nav-item.active .nav-link {
  color: black;
}

.V3 ul.nav.nav-4 .nav-item.active::after {
  content: "";
  position: absolute;
  left: 0px;
  bottom: 0px;
  height: 100%;
  width: 5px;
  border-radius: 0 5px 5px 0;
  background-color: #5E79FF;;
}

.V3 .tab-pane .col-md-5 .col-md-6 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.V3 .new-estimate-item {
  color: #5E79FF !important;
}

.V3 .new-estimate-item i {
  color: #5E79FF !important;
}

.V3 .search-input {
  background: url('data:image/svg+xml;base64,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') no-repeat center right;
  background-position: right 7px center;
  width: 100%;
}

.V3 .search-input:focus {
  width: 100% !important;
}

@media screen and (max-width: 767px) {
  .V3 .active.ml-2 {
    margin-left: 0 !important;
  }
}

.V3 .left-side {
  background: #DFEBF8;
  padding-bottom: 110px;
}

.V3 .left-side hr {
  width: 100%;
  border-bottom: 2px solid #C0D8EF;
  margin: 20px 0;
}

.V3 .left-side h3 {
  color: #142742;
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
  margin-top: 20px;
  margin-bottom: 10px;
}

.V3 .p-20 {
  padding: 20px;
}

.V3 .mt-3 {
  margin-top: 2.3rem !important;
}

.V3 .btn.btn-primary.mt-1.mb-1 {
  margin-bottom: 0.5rem;
}

.V3 .filed-md {
  display: block;
  width: 100%;
  background: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #DDDDDD;
  padding: 15px;
}

.V3 .filed-md::placeholder {
  color: #818A91;
  font-size: 14px;
  font-weight: 600;
}

.V3 .search-field {
  padding-left: 45px;
}

.V3 .search-label {
  position: absolute;
}

.V3 .search-label i {
  position: relative;
  display: block;
  font-size: 20px;
  color: #818A91;
  transform: translate(15px, 17px);
}

.V3 .left-side-nav {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.V3 .left-side-nav li {
  display: flex;
  justify-content: space-between;
  color: #142742;
  font-size: 14px;
  padding: 13px 20px;
  -webkit-transition: 0.2s linear;
  -moz-transition: 0.2s linear;
  -o-transition: 0.2s linear;
  transition: 0.2s linear;
}

.V3 .left-side-nav li:hover {
  background: #EFF5FA;
  color: #0672C3;
}

.V3 .left-side-nav li.active {
  background: #EFF5FA;
}

.V3 .left-side-nav button {
  cursor: pointer;
  width: 20px;
  padding: 0;
  margin-left: 5px;
}

.V3 .left-side-nav i {
  font-size: 20px;
  margin-left: 10px;
}

.V3 .left-side-nav .ti-write {
  color: #142742;
}

.V3 .left-side-nav .ti-trash {
  color: #D0021B;
}

.V3 .nav-tabs.nav-tabs-2 {
  /* border: none;*/
  /*   height: 50px; */
}

.V3 .estimate-items th {
  height: 48px;
  background-color: rgba(27, 30, 56, 0.1) !important;
  color: #1C1F39 !important;
  font-size: 13px;
  font-weight: bold;
  line-height: 18px;
}

.V3 .estimates-edit .browse-btn {
  height: 38px;
  width: 126px;
  border-radius: 3px;
  background-color: #5E79FF;
  color: white;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
}

.V3 .estimates-edit .cancel-btn {
  box-sizing: border-box;
  height: 39px;
  width: 127px;
  border: 1px solid rgba(28, 31, 57, 0.25);
  border-radius: 3px;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
}

.V3 .estimates-edit #upload-images .bx {
  font-size: 37px;
  color: #5E79FF;
}

.V3 .estimates-edit .text-or {
  color: #1C1F39;
  font-family: "Nunito Sans";
  font-weight: 700;
  opacity: 0.25;
  font-size: 13px;
}

.V3 .estimates-edit .tab-content {
  padding-left: 0;
}

.V3 .estimates-edit .pin-checkmark {
  background-color: #FFFFFF;
}

.V3 .estimates-edit #upload-files .dnd-or {
  opacity: 0.25;
  color: #1C1F39;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
}

.V3 .estimates-edit #upload-files .dnd-title {
  color: #1C1F39;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
}

.V3 .estimates-edit #upload-files i {
  font-size: 37px;
  color: #5E79FF
}

.tabs-absolute-right {
  display: inline-flex;
  margin-right: 30px;
}

.V3 .estimates-edit-page .col-form-label {
  padding: 8px 0;
}

.V3 .estimates-edit-page .pin-image {
  align-items: center;
  position: relative;
  color: #34495E;
  height: 27px;
  font-weight: 600;
  font-size: 13px;
  padding-top: 8px;
  padding-left: 35px;
  margin-bottom: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
}

/* Hide the browser's default checkbox */
.V3 .estimates-edit-page .pin-image input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create the checkmark/indicator (hidden when not checked) */
.V3 .estimates-edit-page .pin-checkmark i {
  margin: auto;
  width: 16px;
  display: none;
  font-size: 26px;
  color: white;
  margin-left: -2px;
  margin-top: -2px;
}

/* Show the checkmark when checked */
.V3 .estimates-edit-page .pin-image input:checked ~ .pin-checkmark i {
  display: block;
}

.V3 .estimates-edit-page .card-block {
  padding: 13px;
  overflow: auto;
}

.V3 .estimates-edit-page .shop-bold {
  font-size: 14px;
  line-height: 19px;
  font-weight: bold;
}

.V3 .estimates-edit-page .shop-bold .col-sm-7 {
  padding-left: 0;
}

.V3 .estimates-edit-page .shop-light {
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  display: flex;
  align-items: center;
}

.V3 .estimates-edit-page .shop-light .col-sm-7 {
  padding-left: 0;
}

.V3 .estimates-edit-page .progress {
  border-top: 1px solid rgba(27, 30, 56, 0.25);
  padding-top: 15px;
}

.V3 .estimates-edit-page .progress h2 {
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
}

.V3 .estimates-edit-page .progress .full-activity {
  color: #5E79FF;
  font-size: 13px;
  font-weight: 600;
}

.tabs-absolute-right-notes-btn {
  margin-right: 160px;
}

.button.button.button--light {
  position: relative;
  cursor: pointer;
  border: 0px;
}

.button.button.button--light:active {
  top: 1px;
}

.pdr-menu {
}

.pdr-menu__item {
  position: relative;
}

.pdr-menu__button {
  cursor: pointer;
  border: 0px;
  padding: 0px;
  background: transparent;
}

.pdr-menu__comment {
  position: absolute;
  display: none;
  border-radius: 5px;
  overflow: hidden;
  right: -65%;
  top: 10px;
  background-color: #FFFFFF;

  /* copied from vue-context */
  border: 1px solid #BDBDBD;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);

}

.pdr-menu__item.has-comment:hover .pdr-menu__comment,
.pdr-menu__item.has-comment:focus .pdr-menu__comment,
.pdr-menu__item.has-comment:active .pdr-menu__comment {
  display: flex;
}

.pdr-menu__comment textarea {
  min-height: 100px;
  width: 174px;
  border: 0px;
  padding: 10px;
}

.pdr-visible-icon {
  position: relative;
}

.disabled.pdr-visible-icon:after {
  display: none;
}

.pdr-visible-icon:after {
  content: '/';
  display: grid;
  place-items: center;
  position: absolute;
  top: -5px;
  left: -1px;
  font-weight: 900;
  font-size: 28px;
  transform: rotate(300deg);
  width: 24px;
  height: 24px;
  overflow: hidden;
  text-shadow: -1px -2px #DDDDDD;
}

.V3 .estimates-edit-page.is-mobile .form-control {
  padding-right: 20px !important;
}

.V3 .estimates-edit-page.is-mobile .nav-4 .nav-link {
  padding: .5rem .35rem;
}

.V3 .estimates-edit-page.is-mobile .nav-4 .nav-link i {
  margin-right: .35rem;
}

@media screen and (min-width: 768px) {
  .V3 .vh-height-65 {
    height: calc(100vh - 410px);
    overflow-x: hidden;
    overflow-y: auto;
  }
}

@media screen and (min-width: 991px) {
  .V3 .vh-height-65 {
    height: calc(100vh - 370px);
    overflow-x: hidden;
    overflow-y: auto;
  }
}

@media screen and (min-width: 1024px) {
  .V3 .vh-height-65 {
    height: calc(100vh - 430px);
    overflow-x: hidden;
    overflow-y: auto;
  }
}

@media screen and (min-width: 1300px) {
  .V3 .vh-height-65 {
    height: calc(100vh - 430px);
    overflow-x: hidden;
    overflow-y: auto;
  }
}

@media screen and (min-width: 1515px) {
  .V3 .vh-height-65 {
    height: calc(100vh - 390px);
    overflow-x: hidden;
    overflow-y: auto;
  }
}

@media screen and (min-width: 1580px) {
  .V3 .vh-height-65 {
    height: calc(100vh - 360px);
    overflow-x: hidden;
    overflow-y: auto;
  }
}

@media screen and (min-width: 1820px) {
  .V3 .vh-height-65 {
    height: calc(100vh - 330px);
    overflow-x: hidden;
    overflow-y: auto;
  }
}

.checkbox-group {
  display: flex;
  flex-wrap: wrap;
}

.checkbox-p {
  padding-bottom: 10px;
  padding-right: 10px;
}

@media (max-width: 991px) {
  .col-lg-8 {
    float: right;
    width: 66.666667%;
  }
}

.error-text {
  color: red !important;
}

.white-text {
  color: white !important;
}

.nav-title {
  padding: 10px 15px 0 15px;
}

.invoice .main-table tbody td, .invoice .main-table tfoot td {
  padding: 5px 10px;
}

@media screen and (max-width: 767px) {
  .nav-title {
    padding: 0 10px 0 15px;
  }
}

@media screen and (max-width: 767px) {
  .reset-padd {
    padding-right: 0px;
  }

  .add-padd-mobile {
    padding-right: 15px;
    padding-left: 15px;
  }

  .padd-left-15 {
    padding-left: 15px !important;
  }

  .checkbox-group {
    flex-direction: column;
  }
}

.checkbox-group {
  display: flex;
  flex-wrap: wrap;
}

.checkbox-p {
  padding-bottom: 10px;
  padding-right: 10px;
}

.close-edit-cursor {
  cursor: not-allowed;
}

@media (min-width: 1400px) {
  .numeric-qty {
    min-width: 2.5rem !important;
  }
}

@media screen and (max-width: 991px) {
  .invoice-header {
    flex-direction: column;
  }

  .table-fixed {
    table-layout: fixed;
  }

  .vat {
    display: block;
  }

  .owner-details tr {
    padding-left: 5px;
  }

  .invoice {
    width: 540px;
  }

  .main-flex {
    display: flex;
    flex-direction: column;
  }

  .mobile-disabled {
    display: none;
  }

  .invoice .main-table .vehicle-details td,
  .invoice .main-table .main-inner td {
    padding: 5px 0;
  }
}

@media screen and (max-width: 767px) {
  .invoice-header {
    flex-direction: column;
  }

  .invoice .main-total-table {
    float: left;
  }
}

@media screen and (max-width: 576px) {
  .invoice {
    width: 95%;
  }

  .invoice .main-table thead th {
    padding: 8px 5px;
  }

  .invoice .main-table tbody td, .invoice .main-table tfoot td {
    padding: 5px 0;
  }

  .block-position-wrap {
    flex-wrap: wrap;
    padding-left: 15px;
    justify-content: flex-end;
  }

  .V3 .estimates-edit-page .col-form-label {
    padding-left: 0 !important;
    text-align: left !important;
    min-width: 48px !important;
  }

  .V3 .estimates-edit-page.is-mobile .form-control {
    padding: 0.5rem 5px !important;
  }
}

.V3 .card-header {
  min-height: 48px;
  height: auto;
  align-items: center;
  transform: none;
}


.V3 .card-header {
  padding: 5px 15px !important;
}

.additional-menu-icon {
  position: absolute;
  right: 10px;
  top: 13px;
}

.trash-icon {
  cursor: pointer;
}

.estimate-item-comment {
  position: absolute;
  border-radius: 5px;
  overflow: hidden;
  width: 148px !important;
  height: 121px !important;
  left: 177px !important;
  background-color: #FFFFFF;
  border: 1px solid #BDBDBD;
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 20%), 0 1px 5px 0 rgb(0 0 0 / 12%);
}

.estimate-item-comment textarea {
  height: 119px;
  width: 146px;
  border: none;
  padding: 0.75rem;
  resize: none;
}

.comment-limit-text {
  position: absolute;
  bottom: -5px;
  left: 6px;
  color: #A2ABAE;
}

.save-comment-icon {
  position: absolute;
  bottom: 7px;
  left: 124px;
  font-size: 27px;
  color: #73716C;
}

.save-comment-icon:hover {
  color: #5E79FF;
}

@media screen and (max-width: 1670px) {
  .additional-padding-btn {
    padding-bottom: 10px;
  }
}

.tooltip {
  top: 32px !important;
}

.estimate-items-wrapper {
  margin-right: 10px;
  margin-left: 10px;
}

.estimate-items-title {
  height: 48px;
  background-color: rgba(27, 30, 56, .1) !important;
  color: #1C1F39 !important;
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
  display: flex;
  align-items: center;
}

.estimate-items-title-content {
  padding: 0.75rem;
  width: 70px;
  flex-grow: 0;
}

#estimate-item-list .estimate-items .has-line {
  margin-bottom: 34px;
}

#estimate-item-list .estimate-items .has-line-x2 {
  margin-bottom: 75px;
}

#estimate-item-list .estimate-items .comment-block {
  position: absolute;
  left: 0px;
  width: 100%;
  margin-top: 55px;
  padding-left: 0px;
}

#estimate-item-list .estimate-items .comment-block .comment-text {
  height: 32px;
  padding-left: 20px;
  padding-top: 4px;
  color: #FE9600;
}

#estimate-item-list .estimate-items .comment-block .comment-text span,
#estimate-item-list .estimate-items .comment-block .estimate-comment-text span {
  font-weight: bold;
}

#estimate-item-list .estimate-items .comment-block .estimate-comment-text {
  height: 32px;
  padding-left: 20px;
  padding-top: 4px;
  color: #3CD6B2;
}

#estimate-item-list .estimate-items {
  padding-bottom: 30px !important;
}
</style>
